import React, { useEffect, useState } from 'react'
import styles from './ClientPdf.module.css'
// import Logo from "../../assets/rtr-logo2.png"
// import Logo from "../../assets/pdf-logo.png"
import Logo from "../../assets/logo.png"
import DoughnutChart from '../../components/Chart/DoughnutChart'
import { prpHttpAPI } from '../../services/prpHttpAPI'
import { useLocation, useParams } from 'react-router-dom'
const ClientPdf = () => {
    const [rows, setRows] = useState([]);
    const [nonRetirementRows, setnonRetirementRows] = useState([]);
    const [goalsData, setGoalsData] = useState({});
    const [userData, setUserData] = useState(null);
    const [modifiedPlanId, setmodifiedPlanId] = useState(null);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const { plan_id } = useParams();
    const data = {
        plan_id: plan_id
    }
    // let modifiedPlanId = '';
    useEffect(() => {
        const getPdfDetails = async () => {
            try {
                setLoading(true)
                const result = await prpHttpAPI(data, 'get-pdf/details', null, "POST")
                console.log("result is: ", result);
                let planId = result.clientsDetails?.plan_id || "";
                planId = planId.split('_')[0];  // or planId.replace(/_.*$/, '');

                if (result?.success) {
                    // merge API investmentDetails with localStorage
                    // so capital_receipts / insurance / loans are never empty
                    const prevRaw = localStorage.getItem('clientInvestmentData');
                    const prevLocal = prevRaw ? JSON.parse(prevRaw) : {};
                    const mergedInvestment = {
                        ...result.investmentDetails,
                        capital_receipts: result.investmentDetails?.capital_receipts?.length > 0
                            ? result.investmentDetails.capital_receipts
                            : (prevLocal.capital_receipts || []),
                        insurance_coverage: result.investmentDetails?.insurance_coverage?.length > 0
                            ? result.investmentDetails.insurance_coverage
                            : (prevLocal.insurance_coverage || []),
                        liabilities_loans: result.investmentDetails?.liabilities_loans?.length > 0
                            ? result.investmentDetails.liabilities_loans
                            : (prevLocal.liabilities_loans || []),
                    };
                    const mergedResult = { ...result, investmentDetails: mergedInvestment };

                    setUserData(mergedResult)
                    setmodifiedPlanId(planId)

                    const builtGoalsData = computeGoalsData(mergedResult);   // ← accurate cascade calc (uses merged data)
                    setGoalsData(builtGoalsData);

                    const apiCF = result.planDetails?.cashflow;
                    const apiRet = result.planDetails?.retirementCashflow;

                    if (Array.isArray(apiCF) && apiCF.length > 2) {
                        const finalCF = apiCF.slice(2).map(r => [
                            r[0] ?? 0,                          // Age
                            r[1] ?? 0,                          // Year
                            r[2] ?? 0,                          // Opening Balance
                            r[3] ?? 0,                          // Returns
                            r[4] ?? 0,                          // Current Savings
                            r[5] ?? 0,                          // Additional Savings
                            Math.abs(r[6] ?? 0),                // Goal Withdrawal (positive)
                            r[7] ?? 0,                          // Net Capital Receipts  (col 7)
                            r[8] ?? 0,                          // Net Goal Requirement  (col 8)
                            r[9] ?? 0                           // Year End Value        (col 9)
                        ]);
                        setnonRetirementRows(finalCF);
                    } else {
                        const nonRetData = nonRetirementCashFlow(result);
                    }

                    if (Array.isArray(apiRet) && apiRet.length > 1) {
                        const finalRet = apiRet.slice(1).map(r => [
                            `${r[0]} / ${r[1]}`,  // Age / Year
                            r[2] ?? 0,             // Beginning Assets
                            r[3] ?? 0,             // Annual Return
                            r[4] ?? 0,             // Annual Savings
                            r[5] ?? 0,             // Additional Savings
                            r[6] ?? 0,             // Capital Receipts      (col 6)
                            r[7] ?? 0,             // Expense Withdrawal    (col 7)
                            r[8] ?? 0,             // Goal Withdrawal       (col 8)
                            r[9] ?? 0              // Year End Value        (col 9)
                        ]);
                        setRows(finalRet);
                    } else {
                        const nonRetData = nonRetirementCashFlow(result);
                        cashFlow(result, nonRetData.lastGoalYear);
                    }
                }
            } catch (error) {
                console.log("There is some error after api fetch", error.message);
            } finally {
                setLoading(false)
            }

        }
        getPdfDetails()
    }, [])

    const nonRetirementCashFlow = (userData) => {
        //         let goals = [
        //                {
        //             goal_name: "Child Marriage",
        //             goal_year: 2032,
        //             amount: 2000000
        //         },
        //         {
        //             goal_name: "Child Education",
        //             goal_year: 2045,
        //             amount: 2000000
        //         },

        //         {
        //             goal_name: "House Purchase",
        //             goal_year: 2038,
        //             amount: 5000000
        //         }

        // ]

        let goals = userData.investmentDetails.goals;

        const currentAge = userData.clientsDetails.age;
        const retirementAge = userData.clientsDetails.year_of_retirement;
        const lifeExpectancy = userData.clientsDetails.life_expectancy;
        const yearsUnitilRetirement = userData.planDetails.YearsUnitilRetirement;

        // const totalInvestments = userData.planDetails.totalInvestments;
        const totalNonRetirementInvestment = userData.planDetails.NonRetirementInvestments;
        const totalNonRetirementInvestmentContribution = userData.planDetails.NonRetirementContributions;
        const preRetRor = userData.investmentDetails.pre_ret_ror;
        const postRetRor = userData.investmentDetails.post_ret_ror;
        // const totalContribution = userData.planDetails.TotalContributions;
        // var additionalSaving = userData.planDetails.shortageRYType == 'surplus' ? 0 : userData.planDetails.additionalSavRqd.monthly;
        // const retirementExpenseRY = userData.planDetails.retirementExpanceRY;
        const inflationRate = userData.clientsDetails.inflation_rate;

        const annualSavings = totalNonRetirementInvestmentContribution * 12;

        let additionalSavings = 0;

        let previousYearEndValue = totalNonRetirementInvestment;
        let previousWithdrawal = 0;
        let previousAdditionalSavings = [];
        let newArr = [];
        let current_year = new Date().getFullYear();
        //let addinonalLumsum = [];
        let goalsOutput = {};


        let currentYearLoop = current_year;
        let GRetirmentYear = yearsUnitilRetirement + current_year;
        let age = currentAge;
        for (let yearsUnitRetire = 0; yearsUnitRetire <= yearsUnitilRetirement; yearsUnitRetire++) {



            let shortageGY = 0;
            let investedValue = 0;
            let withdrawal = 0;


            let goalValueAtGY = 0;
            let currentYearWithdrawal = 0;

            goals.forEach((goal) => {
                if (currentYearLoop == (goal.goal_year - 1) && (GRetirmentYear > goal.goal_year)) {
                    goalValueAtGY =
                        goal.amount *
                        Math.pow(
                            (1 + inflationRate / 100),
                            (goal.goal_year - current_year)
                        );

                    currentYearWithdrawal += goalValueAtGY;
                }
            });
            withdrawal = currentYearWithdrawal;
            previousWithdrawal = currentYearWithdrawal;

            // if (currentYearLoop == goals[0].goal_year) {
            //     previousWithdrawal = 0;
            //     goalValueAtGY =
            //         goals[0].amount *
            //         Math.pow(
            //             (1 + inflationRate / 100),
            //             (goals[0].goal_year - current_year)
            //         );

            //     withdrawal = goalValueAtGY;
            //     previousWithdrawal = goalValueAtGY;
            // } else {
            //     withdrawal = 0;
            // }



            // Invested value
            investedValue = age === currentAge ? totalNonRetirementInvestment : previousYearEndValue;

            if (investedValue < 0) {
                investedValue = 0;
            }

            // Annual return
            let annualReturn = (investedValue * ((age == retirementAge || age > retirementAge) ? postRetRor : preRetRor)) / 100;

            if (annualReturn < 0) {
                annualReturn = 0;
            }


            // additionalSavings


            if (userData.planDetails.shortageRYType != 'surplus') {



                goals.forEach((goal, idx) => {
                    if (((goal.goal_year - 1) == currentYearLoop) && (GRetirmentYear > goal.goal_year)) {
                        let goalValueAtGY = goal.amount * Math.pow((1 + inflationRate / 100), (goal.goal_year - current_year));

                        if (goalValueAtGY != 0) {
                            shortageGY = goalValueAtGY - (investedValue + annualSavings + annualReturn);
                        }
                        else {
                            shortageGY = 0;
                        }

                        let r = preRetRor / 100;
                        let n = (goal.goal_year - current_year);

                        additionalSavings =
                            shortageGY /
                            (
                                (Math.pow(1 + r, n) - 1) / r
                            );

                        if (goalValueAtGY < (investedValue + annualSavings + annualReturn)) {
                            additionalSavings = 0;
                            shortageGY = 0;
                        }



                        //previousAdditionalSavings = additionalSavings;
                        previousAdditionalSavings.push({ additionalSavings: additionalSavings, year: currentYearLoop });


                        if (currentYearLoop == '2032') {
                            console.log('test...');
                        }

                        const uniqueKey = `${goal.goal_year}_${idx}`;
                        goalsOutput[uniqueKey] = {
                            goals: goal,
                            currentYearLoop: currentYearLoop,
                            addinonalLumsum: shortageGY / Math.pow((1 + preRetRor / 100), (goal.goal_year - current_year)),
                            amountRequired: goalValueAtGY,
                            shortage: shortageGY,
                            additionalSavings: additionalSavings
                        }
                        if (shortageGY <= 0) {
                            goalsOutput[uniqueKey] = {
                                goals: goal,
                                currentYearLoop: currentYearLoop,
                                addinonalLumsum: 0,
                                amountRequired: goalValueAtGY,
                                shortage: shortageGY,
                                additionalSavings: additionalSavings
                            }
                        }
                        // console.log('additional s ', shortageGY, additionalSaving);
                    }
                });





                // if (goals[0].goal_year == currentYearLoop) {


                //     if (goalValueAtGY != 0) {
                //         shortageGY = goalValueAtGY - (investedValue + annualSavings + annualReturn);
                //         // console.log('shortageGY', currentYearLoop, shortageGY, goalValueAtGY, investedValue, annualSavings, annualReturn);
                //     }
                //     else {
                //         shortageGY = 0;
                //     }

                //     let r = preRetRor / 100;
                //     let n = (goals[0].goal_year - current_year + 1);

                //     additionalSavings =
                //         shortageGY /
                //         (
                //             (Math.pow(1 + r, n) - 1) / r
                //         );


                //     if (currentYearLoop == '2032') {
                //         console.log('test...');
                //     }
                // }
            }



            // Year end value
            const yearEndValue = (investedValue + annualReturn + annualSavings) - withdrawal;
            // console.log('test......', investedValue, annualReturn, annualSavings, additionalSaving, yearEndValue);




            // Save values
            newArr.push([
                age,
                currentYearLoop,
                investedValue,
                annualReturn,
                ((age == retirementAge || age > retirementAge) ? 0 : annualSavings),
                additionalSavings,
                withdrawal,
                (yearEndValue < 0 ? 0 : yearEndValue)
            ]);



            // Prepare for next loop
            previousWithdrawal = withdrawal;
            previousYearEndValue = yearEndValue;
            age++;
            currentYearLoop = currentYearLoop + 1;
            //rows = newArr;
            //setnonRetirementRows(newArr)
        }

        console.log(goalsOutput);
        //   let found = false;
        //   goals.forEach((goal) => {
        //         console.log(goal.goal_year);

        //         Object.entries(goalsOutput).forEach((gl)=>{
        //             if(goal.goal_year == gl[0]){
        //                found = true;
        //               // return 0;
        //             }
        //         });

        //       if (!found) {
        //           goalsOutput[goal.goal_year] = {
        //               goals: goal,
        //               currentYearLoop: 0,
        //               addinonalLumsum: 0,
        //               amountRequired: 0,
        //               shortage: 0,
        //               additionalSavings: 0
        //           }


        //       }
        //       found = false;
        //         // if(goal.year == goalsOutput){

        //         // }
        //   });


        // Run this after your main loop finishes
        goals.forEach((goal, idx) => {
            // Check if this specific goal instance already exists in our output
            const alreadyExists = Object.values(goalsOutput).some(out => out.goals === goal);

            if (!alreadyExists) {
                // Calculate the actual inflated required amount
                const current_year = new Date().getFullYear();
                const inflationRate = userData.clientsDetails.inflation_rate;
                const goalValueAtGY = goal.amount * Math.pow((1 + inflationRate / 100), (goal.goal_year - current_year));

                // Add the missing goal with actual required values
                goalsOutput[`${goal.goal_year}_${idx}`] = {
                    goals: goal,
                    addinonalLumsum: 0,
                    amountRequired: goalValueAtGY,
                    shortage: 0,
                    additionalSavings: 0
                };
            }
        });

        console.log(goalsOutput);


        // newArr = newArr.map((row, ind) => {

        //     // goals.forEach((goal) => {
        //     //     if (row[1] == (goal.goal_year + 1)) {
        //     //         row[5] = 0;
        //     //         additionalSavings = 0;
        //     //         console.log('test', row[0]);
        //     //         // return
        //     //     }
        //     //     else {
        //     //         row[5] = additionalSavings;
        //     //     }
        //     // });

        //         //       if (row[1] == (goals[0].goal_year + 1)) {
        //         //     row[5] = 0;
        //         //     additionalSavings = 0;
        //         //     console.log('test', row[0]);
        //         //     // return
        //         // }
        //         // else {
        //         //     row[5] = additionalSavings;
        //         // }

        //     return row;
        // });

        // previousAdditionalSavings.forEach((val, ind) => {
        //     newArr = newArr.map((row, i) => {
        //         if (row[1] <= val.year) {
        //             row[5] = val.additionalSavings;
        //         }
        //         return row; // ✅ ALWAYS return
        //     });
        // });


        // old sort goals start


        // previousAdditionalSavings.sort((a, b) => a.year - b.year);

        // const lastGoalYear = Math.max(...previousAdditionalSavings.map(g => g.year));


        // Updated sort goals start
        let lastGoalYear;
        if (previousAdditionalSavings.length > 0) {
            previousAdditionalSavings.sort((a, b) => a.year - b.year);
            lastGoalYear = Math.max(...previousAdditionalSavings.map(g => g.year));
        }
        else {
            lastGoalYear = goals.length > 0
                ? Math.max(...goals.map(goal => Number(goal.goal_year)))
                : new Date().getFullYear();

            lastGoalYear = (lastGoalYear - 1);

            console.log("Last Goal Year:", lastGoalYear);
        }


        for (let i = 0; i < newArr.length; i++) {

            let row = newArr[i];

            let age = row[0];
            let year = row[1];

            // ✅ 1. Update Beginning Assets
            if (i > 0) {
                row[2] = newArr[i - 1][newArr[i - 1].length - 1];
            }

            let investedValue = row[2];

            // safety
            if (investedValue < 0) investedValue = 0;

            // ✅ 2. Recalculate Annual Return (IMPORTANT)
            let rate = (age >= retirementAge) ? postRetRor : preRetRor;

            let annualReturn = (investedValue * rate) / 100;

            if (annualReturn < 0) annualReturn = 0;

            row[3] = annualReturn;

            // ✅ 3. Additional Savings logic
            if (year > lastGoalYear) {
                // row[2] = 0;
                // row[3] = 0;
                row[4] = 0;
                row[5] = 0;


            } else {
                let totalSaving = previousAdditionalSavings.reduce((sum, goal) => {
                    if (year <= goal.year) {
                        return sum + goal.additionalSavings;
                    }
                    return sum;
                }, 0);

                row[5] = totalSaving;
            }

            let annualSavings = row[4];
            let additionalSavings = row[5];
            let withdrawal = row[6];

            // ✅ 4. Final Year Ending Value
            let yearEndValue =
                investedValue +
                annualReturn +
                annualSavings +
                additionalSavings -
                withdrawal;

            row[7] = yearEndValue < 0 ? 0 : yearEndValue;

            if (year >= lastGoalYear) {
                // row[7] = 0;
                newArr.splice(i + 1);
                break; // Stop the loop immediately
            }
        }






        // sort goals end


        // setLastGoalYearR('hello');
        setnonRetirementRows(newArr);
        console.log("non retirement cashflow:", newArr);
        // return nonRetirementRows;
        return { rows: newArr, lastGoalYear, goalsOutput };
        // return { rows: nonRetirementRows, lastGoalYear };
    };

    ////////////CASH FLOW//////////////
    const cashFlow = (userData, lastGoalYear) => {
        let current_year = new Date().getFullYear();
        const goals = userData.investmentDetails.goals;
        const currentAge = userData.clientsDetails.age;
        const retirementAge = userData.clientsDetails.year_of_retirement;
        const lifeExpectancy = userData.clientsDetails.life_expectancy;

        let totalInvestments = 0;
        if (goals?.length) {
            totalInvestments = userData.planDetails.RetirementInvestments;
        }
        else {
            totalInvestments = userData.planDetails.totalInvestments;
        }
        const preRetRor = userData.investmentDetails.pre_ret_ror;
        const postRetRor = userData.planDetails.post_ret_ror;
        const inflationRate = userData.clientsDetails.inflation_rate;
        const GRetirmentYear = userData.planDetails.YearsUnitilRetirement + current_year;

        // const annualSavings = userData.planDetails.RetirementContributions * 12;

        let annualSavings = 0;
        if (goals?.length) {
            annualSavings = userData.planDetails.RetirementContributions * 12;
        }
        else {
            annualSavings = userData.planDetails.TotalContributions * 12;
        }

        const AnnualSavingsNonRTR = userData.planDetails.NonRetirementContributions * 12;


        let previousYearEndValue = totalInvestments;
        let previousBaseWithdrawal = 0; // Renamed for clarity
        let newArr = [];
        let currentYearLoop = current_year;

        for (let age = currentAge; age <= lifeExpectancy; age++) {
            if (currentYearLoop == '2042') {
                console.log(currentYearLoop);
            }
            // 1. Beginning Assets (Invested Value)
            const investedValue = age === currentAge ? totalInvestments : previousYearEndValue;

            // 2. Annual Return
            const ror = (age >= retirementAge) ? postRetRor : preRetRor;
            const annualReturn = (investedValue * ror) / 100;


            // 3. Retirement Withdrawal Logic (Base)
            let baseWithdrawal = 0;
            if (age === retirementAge) {
                baseWithdrawal = userData.planDetails.retirementExpanceRY;
            } else if (age > retirementAge) {
                baseWithdrawal = previousBaseWithdrawal * (1 + inflationRate / 100);
            }

            // 4. Goal Withdrawal Logic
            let goalWithdrawalThisYear = 0;
            goals.forEach((goal) => {
                if ((goal.goal_year - 1) === currentYearLoop && goal.goal_year >= GRetirmentYear) {
                    let goalValueAtGY = goal.amount * Math.pow((1 + inflationRate / 100), (goal.goal_year - current_year));
                    goalWithdrawalThisYear += goalValueAtGY;
                }
            });

            const totalWithdrawals = baseWithdrawal + goalWithdrawalThisYear;

            // 5. Savings Logic (Only before retirement)
            let currentAnnualSavings = (age >= retirementAge) ? 0 : annualSavings;
            let currentAdditionalSaving;
            if (userData.planDetails.shortageRYType != 'surplus') {
                currentAdditionalSaving = (age >= retirementAge) ? 0 : (userData.planDetails.additionalSavRqd?.value || 0);
            }
            else {
                currentAdditionalSaving = 0;
            }


            // Non-Retirement Savings deduction logic
            if (currentYearLoop > lastGoalYear && currentYearLoop < GRetirmentYear) {
                //  currentAdditionalSaving = Math.max(0, currentAdditionalSaving - AnnualSavingsNonRTR);
            }

            // 6. Year End Value Calculation
            // Formula: Start + Return + Savings + Additional - Total (Base + Goals)
            let yearEndValue = investedValue + annualReturn + currentAnnualSavings + currentAdditionalSaving - totalWithdrawals;

            // Prevent negative balances
            if (yearEndValue < 0) yearEndValue = 0;

            if (currentYearLoop == '2042') {
                console.log(currentYearLoop);
            }

            // 7. Save row to array
            newArr.push([
                age,                     // 0
                currentYearLoop,         // 1
                investedValue,           // 2
                annualReturn,            // 3
                currentAnnualSavings,    // 4
                currentAdditionalSaving, // 5
                totalWithdrawals,        // 6
                yearEndValue             // 7
            ]);

            // 8. Prepare for next loop
            previousBaseWithdrawal = baseWithdrawal;
            previousYearEndValue = yearEndValue;
            currentYearLoop++;
        }

        setRows(newArr);
        console.log('Retirement cashflow table : ', newArr);
        return newArr;
    };

    // / --- DYNAMIC LOGIC FOR FINANCIAL SUMMARY ---

    // 1. Calculate Retirement Achievement % strictly based on totalAllRetirement
    const calculateAchievement = () => {
        if (!userData || !userData.planDetails) return 0;

        // Investment RY (Future Value of existing assets)
        const invRY = userData.planDetails.totalAllRetirement?.retirement || 0;
        const contribRY = userData.planDetails.totalAllRetirement?.retirementMonthly || 0;


        // Target Corpus required
        const targetForAchievement = userData.planDetails.retirementCorpusRY || 1;
        const safeVal = (v) => (v === null || v === 'NaN' || isNaN(v)) ? 0 : (v || 0);
        const liquidSurplusVal = safeVal(userData?.planDetails?.unallocatedAssetsSurplus);
        const crVal = safeVal(userData?.planDetails?.remainingCapitalReceiptsFV);
        const projectedCorpus = Object.keys(goalsData).length > 0
            ? (invRY + contribRY + liquidSurplusVal + crVal)
            : (invRY + contribRY);
        const achieved = (projectedCorpus / targetForAchievement) * 100;

        // Round and cap at 100
        return Math.min(Math.round(achieved), 100);
    };

    // --- Accurate cascade-based goal calculation (ported from PlanOutput.jsx) ---
    const computeGoalsData = (userData) => {
        const d = userData.investmentDetails;
        const currentYearCascade = new Date().getFullYear();
        const otherLabel = d.other_non_retirement_label || 'Other Liquid';

        // Compute WPreRoR
        const retPctMap = {};
        (d.return_percent || []).forEach(r => { retPctMap[r.asset] = Number(r.return_percent) || 0; });
        const defRet = { mf: 12, stocks: 12, bonds: 8, fdrd: 7, other_liquid: 10 };
        const liqHoldings = {
            mf: Number(d.mf_holding) || 0,
            stocks: Number(d.stocks_holding) || 0,
            bonds: Number(d.bonds_holding) || 0,
            fdrd: Number(d.fdrd_holding) || 0,
            other_liquid: Number(d.other_non_retirement_investment_holding) || 0,
        };
        const totalLiqSum = Object.values(liqHoldings).reduce((s, v) => s + v, 0);
        let WPreRoR = 0.10;
        if (totalLiqSum > 0) {
            const wSum = Object.entries(liqHoldings).reduce((s, [a, h]) =>
                s + h * (retPctMap[a] !== undefined ? retPctMap[a] : (defRet[a] || 0)), 0);
            WPreRoR = wSum / totalLiqSum / 100;
        } else if (d.pre_ret_ror) {
            WPreRoR = Number(d.pre_ret_ror) / 100;
        }
        const CRExpReturn = d.cr_exp_return ? Number(d.cr_exp_return) / 100 : 0.06;
        const capitalReceiptsCascade = d.capital_receipts || [];

        const remainingHoldingsPool = {
            'Mutual Funds': Number(d.mf_holding) || 0,
            'Stocks': Number(d.stocks_holding) || 0,
            'Bonds': Number(d.bonds_holding) || 0,
            'FD/RD': Number(d.fdrd_holding) || 0,
            [otherLabel]: Number(d.other_non_retirement_investment_holding) || 0,
        };
        const remainingSIPsPool = {
            'Mutual Funds': Number(d.mf_monthly) || 0,
            'Stocks': Number(d.stocks_monthly) || 0,
            'Bonds': Number(d.bonds_monthly) || 0,
            'FD/RD': Number(d.fdrd_monthly) || 0,
            [otherLabel]: Number(d.other_non_retirement_investment_monthly) || 0,
        };

        const crRemainingCascade = capitalReceiptsCascade.map(r =>
            Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''))
        );

        let carriedSurplusCR = 0;
        let carriedSurplusInv = 0;
        let lastGoalYearCascade = 0;
        let carriedSips = [];

        const enrichedGoals = [...(d.goals || [])]
            .map((g, idx) => {
                const GoalYear = Number(g.goal_year) || 0;
                const GoalAmtReq = Number(g.amount || 0);
                const LoanFunding = Number(g.loan_amount || 0);
                const n = Math.max(0, GoalYear - currentYearCascade);
                const inf = Number(g.expected_inflation || 5) / 100;
                const GoalRequiredValue = Math.max(0, GoalAmtReq - LoanFunding) * Math.pow(1 + inf, n);
                return { g, idx, GoalYear, GoalRequiredValue, n };
            })
            .sort((a, b) => a.GoalYear - b.GoalYear)
            .map(item => {
                const { g, n } = item;
                let goalHoldingSum = 0;
                let goalSipSum = 0;

                const allocatedInvestments = (g.additional_investment || []).map(row => {
                    if (!row.name) return { ...row, actualHolding: 0, actualSip: 0 };
                    const rawH = Number(row.amount || row.CurrentAvailable || 0);
                    const rawS = Number(row.sip_amount || row.SIPAmt || 0);
                    const aH = Math.min(rawH, remainingHoldingsPool[row.name] || 0);
                    const aS = Math.min(rawS, remainingSIPsPool[row.name] || 0);
                    remainingHoldingsPool[row.name] = Math.max(0, (remainingHoldingsPool[row.name] || 0) - aH);
                    remainingSIPsPool[row.name] = Math.max(0, (remainingSIPsPool[row.name] || 0) - aS);
                    goalHoldingSum += aH;
                    goalSipSum += aS;
                    return { ...row, actualHolding: aH, actualSip: aS };
                });

                const InvestmentTaggedFV = goalHoldingSum * Math.pow(1 + WPreRoR, n);
                const AI = Number(g.stepup_sip || g.step_up || 0) / 100;
                let MonthlyInvestmentFV = 0;
                if (n > 0 && goalSipSum > 0) {
                    if (AI === 0) {
                        const r_m = WPreRoR / 12;
                        MonthlyInvestmentFV = r_m > 0
                            ? goalSipSum * ((Math.pow(1 + r_m, n * 12) - 1) / r_m)
                            : goalSipSum * n * 12;
                    } else if (Math.abs(WPreRoR - AI) < 0.000001) {
                        MonthlyInvestmentFV = goalSipSum * 12 * n * Math.pow(1 + WPreRoR, n - 1);
                    } else {
                        MonthlyInvestmentFV = goalSipSum * 12 *
                            (Math.pow(1 + WPreRoR, n) - Math.pow(1 + AI, n)) / (WPreRoR - AI);
                    }
                }
                return { ...item, InvestmentTaggedFV, MonthlyInvestmentFV, allocatedInvestments };
            });

        const builtGoalsData = {};

        for (const item of enrichedGoals) {
            const { g, GoalYear, GoalRequiredValue, InvestmentTaggedFV, n } = item;
            const futureCapitalReceipts = capitalReceiptsCascade
                .filter(cr => Number(cr.year || cr.CRYear || 0) > GoalYear)
                .reduce((sum, cr) => sum + Number(cr.amount || cr.CRAmt || 0), 0);

            let CapReceiptsAtGoalYear = 0;
            let remainingToSettle = GoalRequiredValue;

            if (carriedSurplusCR > 0 && lastGoalYearCascade > 0 && GoalYear > lastGoalYearCascade && remainingToSettle > 0) {
                const yrs = GoalYear - lastGoalYearCascade;
                const compounded = carriedSurplusCR * Math.pow(1 + CRExpReturn, yrs);
                const apply = Math.min(compounded, remainingToSettle);
                CapReceiptsAtGoalYear += apply;
                remainingToSettle -= apply;
                carriedSurplusCR -= apply / Math.pow(1 + CRExpReturn, yrs);
            }

            if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear > lastGoalYearCascade && remainingToSettle > 0) {
                const yrs = GoalYear - lastGoalYearCascade;
                const compounded = carriedSurplusInv * Math.pow(1 + WPreRoR, yrs);
                const apply = Math.min(compounded, remainingToSettle);
                CapReceiptsAtGoalYear += apply;
                remainingToSettle -= apply;
                carriedSurplusInv -= apply / Math.pow(1 + WPreRoR, yrs);
            }

            const crSnapshotBeforeGoal = [...crRemainingCascade];

            for (let i = 0; i < capitalReceiptsCascade.length; i++) {
                if (remainingToSettle <= 0.01) break;
                if ((crRemainingCascade[i] || 0) <= 0.01) continue;
                const cr = capitalReceiptsCascade[i];
                const CRYear = Number(cr.year || cr.CRYear || 0);

                if (GoalYear >= CRYear) {
                    const yrs = Math.max(0, GoalYear - CRYear);
                    const growthFactor = Math.pow(1 + CRExpReturn, yrs);
                    const maxFV = crRemainingCascade[i] * growthFactor;
                    const crFV = Math.min(maxFV, remainingToSettle);
                    CapReceiptsAtGoalYear += crFV;
                    remainingToSettle -= crFV;
                    crRemainingCascade[i] -= crFV / growthFactor;
                }
            }

            if (carriedSips.length > 0 && GoalYear > 0) {
                let prevSipFV = 0;
                carriedSips.forEach(sip => {
                    if (GoalYear <= sip.PreviousGoalYear) return;
                    const yearsGap = GoalYear - sip.PreviousGoalYear;
                    const yearsToPrev = sip.PreviousGoalYear - currentYearCascade;
                    const sipStart = sip.SIPAmt * Math.pow(1 + sip.AI, yearsToPrev);
                    if (Math.abs(WPreRoR - sip.AI) < 0.000001) {
                        prevSipFV += sipStart * 12 * ((Math.pow(1 + WPreRoR, yearsGap) - 1) / WPreRoR);
                    } else {
                        prevSipFV += sipStart * 12 *
                            (Math.pow(1 + WPreRoR, yearsGap) - Math.pow(1 + sip.AI, yearsGap)) /
                            (WPreRoR - sip.AI);
                    }
                    sip.PreviousGoalYear = GoalYear;
                });
                CapReceiptsAtGoalYear += prevSipFV;
                remainingToSettle -= prevSipFV;
            }

            const holdingFVUsed = Math.min(InvestmentTaggedFV, remainingToSettle);
            remainingToSettle = Math.max(0, remainingToSettle - InvestmentTaggedFV);

            const sipFVUsed = Math.min(item.MonthlyInvestmentFV, remainingToSettle);
            remainingToSettle = Math.max(0, remainingToSettle - item.MonthlyInvestmentFV);

            const TotalAvailable = holdingFVUsed + sipFVUsed + CapReceiptsAtGoalYear;
            const GoalNetReq = Math.max(0, GoalRequiredValue - TotalAvailable);
            const newSurplus = Math.max(0, TotalAvailable - GoalRequiredValue);

            if (GoalNetReq > 0) {
                carriedSurplusCR = 0;
                carriedSurplusInv = 0;
            } else {
                if (carriedSurplusInv > 0 && lastGoalYearCascade > 0 && GoalYear > lastGoalYearCascade) {
                    carriedSurplusInv *= Math.pow(1 + WPreRoR, GoalYear - lastGoalYearCascade);
                }
                carriedSurplusInv += newSurplus;
            }

            const currentAI = Number(g.stepup_sip || g.step_up || g.GrowthRate || 0) / 100;
            (item.allocatedInvestments || []).forEach(row => {
                if ((row.actualSip || 0) > 0) {
                    carriedSips.push({ SIPAmt: row.actualSip, AI: currentAI, PreviousGoalYear: GoalYear });
                }
            });

            if (GoalYear > lastGoalYearCascade) {
                lastGoalYearCascade = GoalYear;
            }

            let indicativeSip = 0;
            if (n > 0 && GoalNetReq > 0) {
                const r = WPreRoR;
                const rawStepUp = g.stepup_sip || g.step_up || g.GrowthRate || 0;
                const stepupVal = (isNaN(Number(String(rawStepUp).replace(/[^0-9.-]/g, '')))
                    ? 0
                    : Number(String(rawStepUp).replace(/[^0-9.-]/g, ''))) / 100;
                if (r === stepupVal) {
                    const denom = n * Math.pow(1 + r, n - 1);
                    indicativeSip = denom > 0 ? GoalNetReq / denom : 0;
                } else if (r > 0) {
                    const denom = (Math.pow(1 + r, n) - Math.pow(1 + stepupVal, n)) / (r - stepupVal);
                    indicativeSip = denom > 0 ? GoalNetReq / denom : 0;
                }
                indicativeSip = indicativeSip / 12;
            }
            const indicativeLumpsum = n > 0
                ? Math.max(0, GoalNetReq / Math.pow(1 + WPreRoR, n))
                : 0;
            const key = `${g.goal_year}_${item.idx}`;

            builtGoalsData[key] = {
                goals: g,
                amountRequired: GoalRequiredValue,
                taggedInvestmentsFV: holdingFVUsed,
                monthlyInvestmentFV: sipFVUsed,
                capitalReceiptFV: CapReceiptsAtGoalYear,
                futureCapitalReceipts: futureCapitalReceipts,
                totalProjected: holdingFVUsed + sipFVUsed + CapReceiptsAtGoalYear,
                shortage: GoalNetReq,
                additionalSavings: indicativeSip,
                addinonalLumsum: indicativeLumpsum,
                crRemainingSnapshot: crSnapshotBeforeGoal
            };
        }

        return builtGoalsData;
    };

    const getAllocationForGoal = (yearsAway, ror) => {
        // Long Term: More than 9 years
        if (yearsAway >= 10) {
            if (ror <= 12) return { Equity: 65, Bond: 20, Cash: 5, Gold: 7,  Silver: 3, riskProfile: 'Low risk',      timeHorizon: 'Long' };
            if (ror <= 16) return { Equity: 75, Bond: 10, Cash: 5, Gold: 5,  Silver: 5, riskProfile: 'Moderate risk', timeHorizon: 'Long' };
            return             { Equity: 85, Bond: 5,  Cash: 0, Gold: 5,  Silver: 5, riskProfile: 'High Risk',     timeHorizon: 'Long' };
        }
        // Medium Term: 5 to 9 years
        if (yearsAway >= 5) {
            if (ror <= 10) return { Equity: 50, Bond: 30, Cash: 5, Gold: 10, Silver: 5, riskProfile: 'Low risk',      timeHorizon: 'Medium' };
            if (ror <= 14) return { Equity: 65, Bond: 20, Cash: 5, Gold: 7,  Silver: 3, riskProfile: 'Moderate risk', timeHorizon: 'Medium' };
            return             { Equity: 75, Bond: 10, Cash: 5, Gold: 5,  Silver: 5, riskProfile: 'High Risk',     timeHorizon: 'Medium' };
        }
        // Short Term: 0 to 4 years
        if (ror <= 8)  return { Equity: 40, Bond: 35, Cash: 10, Gold: 10, Silver: 5, riskProfile: 'Low risk',      timeHorizon: 'Short' };
        if (ror <= 12) return { Equity: 50, Bond: 30, Cash: 5,  Gold: 10, Silver: 5, riskProfile: 'Moderate risk', timeHorizon: 'Short' };
        return             { Equity: 60, Bond: 25, Cash: 5,  Gold: 7,  Silver: 3, riskProfile: 'High Risk',     timeHorizon: 'Short' };
    };

    // --- Single source of truth for gap/SIP, mirrors PlanOutput.jsx ---
    const safeNum = (v) => (v === null || v === undefined || v === 'NaN' || isNaN(v)) ? 0 : (Number(v) || 0);
    const hasGoalsForCorpus = Object.keys(goalsData).length > 0;
    const isSingleGoal = Object.keys(goalsData || {}).length === 1;
    const liquidSurplus = safeNum(userData?.planDetails?.unallocatedAssetsSurplus);
    const unallocatedCapitalReceiptsFV = safeNum(userData?.planDetails?.remainingCapitalReceiptsFV);
    const retInvProjected = safeNum(userData?.planDetails?.totalAllRetirement?.retirement)
        + safeNum(userData?.planDetails?.totalAllRetirement?.retirementMonthly);
    const projectedTotalCorpus = retInvProjected + unallocatedCapitalReceiptsFV + liquidSurplus;
    const targetCorpus = safeNum(userData?.planDetails?.retirementCorpusRY);
    const correctedGap = Math.max(0, targetCorpus - projectedTotalCorpus);
    const correctedSurplus = Math.max(0, projectedTotalCorpus - targetCorpus);
    const backendGap = safeNum(userData?.planDetails?.shortageRY);
    const backendSIPMonthly = safeNum(userData?.planDetails?.additionalSavRqd?.monthly);
    const correctedSIPMonthly = (backendGap > 0 && backendSIPMonthly > 0)
        ? Math.round(correctedGap * (backendSIPMonthly / backendGap))
        : backendSIPMonthly;
    const correctedLumpsum = (backendGap > 0 && safeNum(userData?.planDetails?.additionalLumsumRqd?.value) > 0)
        ? Math.round(correctedGap * (safeNum(userData?.planDetails?.additionalLumsumRqd?.value) / backendGap))
        : safeNum(userData?.planDetails?.additionalLumsumRqd?.value);

    const equityPct = userData?.planDetails?.equityFunds?.allocation ?? 0;
    const debtPct = userData?.planDetails?.ConservativeHF?.allocation ?? 0;
    const cashPct = userData?.planDetails?.MTDebtAllocation?.allocation ?? 0;
    const goldPct = userData?.planDetails?.goldAllocation?.allocation ?? 0;
    const silverPct = userData?.planDetails?.silverAllocation?.allocation ?? 0;
    const stDebtPct = userData?.planDetails?.STDebtAllocation?.allocation ?? 0;

    const retPercent = calculateAchievement();
    const retGap = 100 - retPercent;

    // Logic Toggle: If achievement is 100, we use Scenario 2
    const isRetirementShortLogic = retPercent < 100;

    // 2. Extract Goals and categorize them safely
    const allGoalsList = goalsData ? Object.values(goalsData) : [];

    // nullOrNaN check
    const checkForNullOrNaN = (value) => {
        return (value === null || value === 'NaN' || isNaN(value)) ? 0 : value;
    }

    // Safe map with optional chaining and fallback to empty string
    const fundedGoalTypes = allGoalsList
        .filter(g => g && checkForNullOrNaN(g.shortage) < 1)
        .map(g => g.goals?.goal_type?.toLowerCase() || "other goal");

    const shortGoalTypes = allGoalsList
        .filter(g => g && checkForNullOrNaN(g.shortage) >= 1)
        .map(g => g.goals?.goal_type?.toLowerCase() || "other goal");

    // --- Retirement counts as its own implicit "goal" alongside the mapped life goals ---
    const isRetirementFunded = userData?.planDetails?.shortageRYType === 'surplus';
    const totalGoalsWithRetirement = allGoalsList.length + 1;
    const fundedGoalsWithRetirement = fundedGoalTypes.length + (isRetirementFunded ? 1 : 0);
    const shortGoalsWithRetirement = shortGoalTypes.length + (isRetirementFunded ? 0 : 1);

    // 3. Grammar Helper (joining array with commas and "and")
    const formatList = (arr) => {
        if (!arr || arr.length === 0) return "";

        // Remove duplicates (e.g., if there are two "child education" goals)
        const uniqueGoals = [...new Set(arr)];

        if (uniqueGoals.length === 1) return uniqueGoals[0];
        const temp = [...uniqueGoals];
        const last = temp.pop();
        return temp.join(", ") + " and " + last;
    };






    //  date fomatting 
    const formatDate = (dateString) => {
        if (!dateString) return '—';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '—';
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'
        }).format(date);
    }
    // make values to crores and lakh 

    function formatNumberToIndianUnits(num) {
        let flag = false;
        if (num < 0) flag = true;
        num = Math.abs(num)
        if (num >= 1e7) {
            return (flag ? -(num / 1e7).toFixed(2) + " Cr" : (num / 1e7).toFixed(2) + " Cr");
        }
        else if (num >= 1e5) {
            return (flag ? -(num / 1e5).toFixed(2) + " Lakh" : (num / 1e5).toFixed(2) + " Lakh");
        }
        else {
            return (flag ? -Intl.NumberFormat('en-IN').format(num.toFixed(2)) : Intl.NumberFormat('en-IN').format(num.toFixed(2)));
        }
    }

    // Formatter for Insurance values (e.g. 1.5 Cr, 10 L, 50,000)
    function formatInsuranceValue(num) {
        if (!num || isNaN(num)) return "0";
        if (num >= 10000000) { // 1 Crore = 100 Lakhs
            const crores = num / 10000000;
            return (crores % 1 === 0 ? crores.toFixed(0) : crores.toFixed(2)) + " Cr";
        }
        if (num >= 100000) {
            const lakhs = num / 100000;
            return (lakhs % 1 === 0 ? lakhs.toFixed(0) : lakhs.toFixed(1)) + " L";
        }
        return Intl.NumberFormat('en-IN').format(Math.round(num));
    }

    const renderRetirementCorpusAnalysis = () => {
        const equityPct = userData?.planDetails?.equityFunds?.allocation ?? 0;
        const debtPct = userData?.planDetails?.ConservativeHF?.allocation ?? 0;
        const cashPct = userData?.planDetails?.MTDebtAllocation?.allocation ?? 0;
        const goldPct = userData?.planDetails?.goldAllocation?.allocation ?? 0;
        const silverPct = userData?.planDetails?.silverAllocation?.allocation ?? 0;

        const projected = checkForNullOrNaN(userData.planDetails.totalAllRetirement?.retirement || userData.planDetails.graph.investment.investmentAmount)
            + checkForNullOrNaN(userData.planDetails.totalAllRetirement?.retirementMonthly || userData.planDetails.graph.retirementContributions.retirementContributionsAmount)
            + checkForNullOrNaN(userData.planDetails.unallocatedAssetsSurplus);
        const isSurplus = userData.planDetails.shortageRYType === 'surplus';
        const additionalSIP = checkForNullOrNaN(userData.planDetails.additionalSavRqd?.monthly);
        const retirementCalendarYear = new Date().getFullYear() - (userData?.clientsDetails?.age || 0) + (userData?.clientsDetails?.year_of_retirement || 0);

        return (
            <div className={`${isSingleGoal ? '' : styles.newSectionCard} pdf-atomic`} style={isSingleGoal ? { marginBottom: '1.25rem' } : {}}>
                <h3 className={styles.investmentHeading}>Retirement Corpus Analysis</h3>
                <div className={styles.corpusAnalysisDiv} style={isSingleGoal ? { padding: '8px 14px', marginTop: '0.25rem' } : {}}>
                    <div className={styles.corpusStatGrid} style={isSingleGoal ? { gap: '8px', marginBottom: '8px' } : {}}>
                        <div className={styles.corpusStatCard}>
                            <div className={styles.corpusStatLabel}>TARGET CORPUS</div>
                            <div className={styles.corpusStatValue}>{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}</div>
                            <div className={styles.corpusStatSub}>ADJUSTED FOR POST-RET-GOALS</div>
                        </div>
                        <div className={styles.corpusStatCard}>
                            <div className={styles.corpusStatLabel}>PROJECTED CORPUS</div>
                            <div className={styles.corpusStatValue}>₹{formatNumberToIndianUnits(projected)}</div>
                            <div className={styles.corpusStatSub}>{isSurplus ? 'WITH SURPLUS' : 'WITH RETIREMENT INVESTMENTS'}</div>
                        </div>
                        <div className={styles.corpusStatCard}>
                            <div className={styles.corpusStatLabel}>ADDITIONAL SIP NEEDED</div>
                            <div className={styles.corpusStatValue}>
                                {isSurplus ? <span style={{ color: '#16a34a' }}>NOT REQUIRED ✓</span> : `₹${Intl.NumberFormat('en-IN').format(additionalSIP)}/mo`}
                            </div>
                            <div className={styles.corpusStatSub}>{isSurplus ? 'CORPUS TARGET ALREADY MET' : 'AFTER GOAL SIPs REDIRECT IN'}</div>
                        </div>
                    </div>

                    <table className={styles.corpusTable} style={isSingleGoal ? { marginTop: '0.75rem' } : {}}>
                        <thead>
                            <tr>
                                <th>PHASE</th>
                                <th>PERIOD</th>
                                <th>GOAL SIP (NET)</th>
                                <th>REDIRECTS TO RETIREMENT</th>
                                <th style={{ textAlign: 'center' }}>STEP-UP</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={styles.corpusTableRowHighlight}>
                                <td>All goals achieved → Full SIP to Retirement</td>
                                <td>{retirementCalendarYear} (Retirement)</td>
                                <td>—</td>
                                <td>₹0/mo total</td>
                                <td style={{ textAlign: 'center' }}>Reduces gap</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className={styles.corpusAllocPanel} style={isSingleGoal ? { marginTop: '0.5rem' } : {}}>
                        <div className={styles.corpusAllocInner} style={isSingleGoal ? { padding: '10px 14px' } : {}}>
                            <div className={styles.corpusAllocTitle}>RECOMMENDED ALLOCATION</div>
                            <div className={styles.corpusAllocBars}>
                                {[
                                    { label: 'Equity', pct: equityPct, color: '#2a78d6' },
                                    { label: 'Debt', pct: debtPct, color: '#1baf7a' },
                                    { label: 'Cash', pct: cashPct, color: '#eb6834' },
                                    { label: 'Gold', pct: goldPct, color: '#eda100' },
                                    { label: 'Silver', pct: silverPct, color: '#94a3b8' },
                                ].filter(b => b.pct > 0).sort((a, b) => b.pct - a.pct).map(b => (
                                    <div key={b.label} className={styles.corpusAllocBarRow}>
                                        <span className={styles.corpusAllocBarLabel}>{b.label}</span>
                                        <div className={styles.corpusAllocBarTrack}>
                                            <div className={styles.corpusAllocBarFill} style={{ width: `${b.pct}%`, background: b.color }} />
                                        </div>
                                        <span className={styles.corpusAllocBarPct}>{b.pct}%</span>
                                    </div>
                                ))}
                            </div>
                            {isSurplus ? (
                                <div className={styles.corpusAllocCalloutSuccess}>NO ADDITIONAL INVESTMENTS NEEDED — CORPUS TARGET ALREADY MET ✓</div>
                            ) : additionalSIP > 0 ? (
                                <div className={styles.corpusAllocCallout}>INVEST <b>₹{Intl.NumberFormat('en-IN').format(additionalSIP)}/mo</b> ACROSS THIS MIX </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>

            {userData ? <div className={styles.main}>
                {loading && <div>LOADING</div>}

                <div className='pdf-page-one '>
                    {/* Header */}
                    {/* <div className={styles.header + ' text-center'}>
                        <header className={styles.headerInner}>
                            <img className={styles.headImg} src={Logo} alt="BajajLogo" />
                            <div className={styles.planIdHeader}>
                                <span>Your Plan ID : </span>
                                <span><b>{userData.clientsDetails.plan_id}</b></span>
                            </div>
                        </header>
                        <div className={styles.headText}>
                            <p>PRE-RETIREMENT PLAN</p>
                        </div>
                    </div> */}
                    <div className={styles.newBanner}>
                        <span className={styles.newBannerPlanId}>
                            Plan ID: {
                                userData?.clientsDetails?.plan_id ||
                                userData?.investmentDetails?.plan_id ||
                                JSON.parse(localStorage.getItem('userData') || '{}')?.plan_id ||
                                '—'
                            }
                        </span>
                        <span className={styles.newBannerDate}>
                            {formatDate(userData?.clientsDetails?.created_at)}
                        </span>
                    </div>
                    <div className={styles.newHeadText}>
                        <div className={styles.newHeadTextLogoRow}>
                            <span className={styles.newHeadTextIncubatedBy}>Incubated By</span>
                            <img src={Logo} alt="Bajaj Capital" className={styles.newHeadTextLogo} />
                        </div>
                        <p style={{ margin: 0 }}>PRE-RETIREMENT PLAN</p>
                    </div>

                    {/* Client Info Row: Dear / RM Name / Prepared On */}
                    {/* <div className={styles.clientDiv + ' text-center'}>
                        <div className={styles.clientChild}>
                            <div className={styles.clientInfoChild}>
                                <p className={styles.clientInfoLabel}>DEAR</p>
                                <p><b>{userData?.clientsDetails?.client_name}</b></p>
                            </div>
                            <div className={styles.clientInfoChild}>
                                <p className={styles.clientInfoLabel}>RM NAME &amp; LOCATION</p>
                                <p><b>{userData.clientsDetails.spoc_rm_name ? userData.clientsDetails.spoc_rm_name : (userData.clientsDetails?.rm_details ? JSON.parse(userData.clientsDetails.rm_details).name : "No RM Name")} / {userData.clientsDetails.spoc_rm_branch ? userData.clientsDetails.spoc_rm_branch : (JSON.parse(localStorage.getItem('rmInfo'))?.BRANCH_NAME || 'Retirement Team')}</b></p>
                            </div>
                            <div className={styles.clientInfoChild}>
                                <p className={styles.clientInfoLabel}>PREPARED ON</p>
                                <p><b>{formatDate(userData?.clientsDetails?.created_at)}</b></p>
                            </div>
                        </div>
                    </div> */}
                    <div className={styles.newInfoGridContainer}>
                        <div className={styles.newInfoGrid}>
                            {[
                                {
                                    label: 'CLIENT',
                                    value: userData?.clientsDetails?.client_name ||
                                        JSON.parse(localStorage.getItem('userData') || '{}')?.client_name ||
                                        '—'
                                },
                                { label: 'CURRENT AGE', value: `${checkForNullOrNaN(userData.clientsDetails.age)}Y` },
                                { label: 'RETIREMENT YEAR', value: new Date().getFullYear() - checkForNullOrNaN(userData.clientsDetails.age) + checkForNullOrNaN(userData.clientsDetails.year_of_retirement) },
                                { label: 'LIFE EXPECTANCY', value: `${checkForNullOrNaN(userData.clientsDetails.life_expectancy)}Y` },
                                { label: 'ANNUAL INCOME', value: `₹${formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.annual_income))}` },
                                { label: 'INCOME GROWTH', value: `${userData?.clientsDetails?.annual_growth_rate ?? 0}% p.a.` },
                                { label: 'RETIREMENT AGE', value: `${userData?.clientsDetails?.year_of_retirement}Y` },
                                { label: 'YEARS TO RETIREMENT', value: `${userData?.planDetails?.YearsUnitilRetirement}Y` },
                                {
                                    label: 'RM',
                                    value: userData.clientsDetails.spoc_rm_name
                                        || userData.clientsDetails.spoc_rm
                                        || userData.clientsDetails.rm_code
                                        || (() => {
                                            try {
                                                return userData.clientsDetails.rm_details
                                                    ? JSON.parse(userData.clientsDetails.rm_details).name
                                                    : null;
                                            } catch { return null; }
                                        })()
                                        || 'Advisor'
                                },
                                { label: 'DATE CREATED', value: formatDate(userData?.clientsDetails?.created_at) },
                            ].map((item, i) => (
                                <div key={i} className={styles.newInfoItem}>
                                    <span className={styles.newInfoLabel}>{item.label}</span>
                                    <span className={styles.newInfoValue}>{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={styles.newSummaryBar}>
                        <b>Inflation Rate:</b> {userData?.clientsDetails?.inflation_rate}% p.a.
                        {userData?.investmentDetails?.goals?.length > 0 && (
                            <>
                                &nbsp;|&nbsp;
                                {userData.investmentDetails.goals.map((goal, idx) => {
                                    const goalIconMap = { 'Child Education': '🎓', 'Child Marriage': '💍', 'Home Purchase': '🏠', 'Vehicle': '🚗', 'Vacation': '✈️', 'Other Goals': '🎯' };
                                    const icon = goalIconMap[goal.goal_type] || '🎯';
                                    return (
                                        <span key={idx}>
                                            {idx > 0 && <span style={{ margin: '0 6px', opacity: 0.5 }}>•</span>}
                                            {icon} {goal.goal_type} — {goal.goal_name || goal.child_name}: {goal.expected_inflation || userData?.clientsDetails?.inflation_rate}%
                                        </span>
                                    );
                                })}
                            </>
                        )}
                    </div>

                    {/* 4 Stat Boxes */}
                    {/* <div className={styles.statBoxRow}>
                        <div className={styles.statBox}>
                            <p className={styles.statLabel}>CURRENT AGE</p>
                            <p className={styles.statValue}>{checkForNullOrNaN(userData.clientsDetails.age)}Y</p>
                        </div>
                        <div className={styles.statBox}>
                            <p className={styles.statLabel}>RETIREMENT YEAR</p>
                            <p className={styles.statValue}>{new Date().getFullYear() - checkForNullOrNaN(userData.clientsDetails.age) + checkForNullOrNaN(userData.clientsDetails.year_of_retirement)}</p>
                        </div>
                        <div className={styles.statBox}>
                            <p className={styles.statLabel}>LIFE EXPECTANCY</p>
                            <p className={styles.statValue}>{checkForNullOrNaN(userData.clientsDetails.life_expectancy)}Y</p>
                        </div>
                        <div className={styles.statBox}>
                            <p className={styles.statLabel}>INFLATION RATE</p>
                            <p className={styles.statValue}>{checkForNullOrNaN(userData.clientsDetails.inflation_rate)}%</p>
                        </div>
                        <div className={styles.statBox}>
                            <p className={styles.statLabel}>ANNUAL INCOME</p>
                            <p className={styles.statValue}>{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.annual_income))}</p>
                        </div>
                    </div> */}

                    {/* Monthly Expenses + Rate of Return Cards */}
                    {/* <div className={styles.infoCardsRow}>
                        <div className={styles.cardPink}>
                            <p className={styles.cardTitle}>MONTHLY EXPENSES</p>
                            <div className={styles.cardValues}>
                                <div>
                                    <p className={styles.cardAmount}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))}</p>
                                    <p className={styles.cardSub}>If Retire Today</p>
                                </div>
                                <div className='text-center'>
                                    <p className={styles.cardAmount}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementExpanceRYMonthly))}</p>
                                    <p className={styles.cardSub}>At Retirement</p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.cardBlue}>
                            <p className={styles.cardTitle}>RATE OF RETURN P.A EXPECTED</p>
                            <div className={styles.cardValues}>
                                <div>
                                    <p className={styles.cardAmount}>{checkForNullOrNaN(userData.investmentDetails.pre_ret_ror)}%</p>
                                    <p className={styles.cardSub}>Before Retirement</p>
                                </div>
                                <div className='text-center'>
                                    <p className={styles.cardAmount}>{checkForNullOrNaN(userData.investmentDetails.post_ret_ror)}%</p>
                                    <p className={styles.cardSub}>After Retirement</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className={styles.newExpenseCard}>
                        <div className={styles.newExpenseCardCol}>
                            <span className={styles.newHighlightLabel}>MONTHLY EXPENSES</span>
                            <span className={styles.newHighlightValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))}</span>
                            <span className={styles.newHighlightSub}>If retire today</span>
                        </div>
                        <div className={styles.newExpenseCardCol}>
                            <span className={styles.newHighlightLabel}>AT RETIREMENT ({new Date().getFullYear() - (userData?.clientsDetails?.age || 0) + (userData?.clientsDetails?.year_of_retirement || 0)})</span>
                            <span className={styles.newHighlightValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementExpanceRYMonthly))}</span>
                            <span className={styles.newHighlightSub}>Inflation adjusted @ {userData?.clientsDetails?.inflation_rate}%</span>
                        </div>
                    </div>

                    <div className={styles.newRatesCard}>
                        {(() => {
                            const retirementReturn = Number(userData?.planDetails?.cashflowParams?.weightedRPreROR ?? 8).toFixed(2);
                            const liquidReturn = Number(userData?.planDetails?.cashflowParams?.weightedPreROR ?? 8).toFixed(2);

                            const postRet = (() => {
                                const raw = userData?.investmentDetails?.post_ret_ror ?? userData?.planDetails?.post_ret_ror ?? 0;
                                const rounded = Math.round(Number(raw) * 2) / 2;
                                return rounded % 1 === 0 ? rounded : rounded.toFixed(1);
                            })();

                            return [
                                { label: 'RETIREMENT INSTRUMENTS RETURN (WEIGHTED AVG 🔒)', value: `${retirementReturn}%`, cls: styles.newRateValueGreen },
                                { label: 'LIQUID INSTRUMENTS RETURN (WEIGHTED AVG 🔒)', value: `${liquidReturn}%`, cls: styles.newRateValueGreen },
                                { label: 'POST-RETIREMENT RETURN', value: `${postRet}%`, cls: styles.newRateValueOrange },
                                { label: 'INFLATION RATE', value: `${userData?.clientsDetails?.inflation_rate}%`, cls: styles.newRateValueOrange },
                            ].map((item, i) => (
                                <div key={i} className={styles.newRateItem}>
                                    <span className={styles.newRateLabel}>{item.label}</span>
                                    <span className={`${styles.newRateValue} ${item.cls}`}>{item.value}</span>
                                </div>
                            ));
                        })()}
                    </div>

                    <div className="pdf-atomic">
                        <div className={styles.financialSummaryBox}>
                            <div className={styles.financialSummaryTitle}><span>📋</span> Your Financial Health Summary</div>
                            <div className={styles.financialSummaryText}>
                                {userData.planDetails.shortageRYType === 'surplus' ? (
                                    <>
                                        Your retirement investments are projected at <b>₹{formatNumberToIndianUnits(retInvProjected)}</b> and a liquid assets surplus of <b>₹{formatNumberToIndianUnits(liquidSurplus)}</b> — aggregating to a net value of <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b> against a retirement target of <b>{formatNumberToIndianUnits(targetCorpus)}</b>. A net surplus of <b style={{ color: '#16a34a' }}>₹{formatNumberToIndianUnits(correctedSurplus)}</b> exists. <span style={{ color: '#16a34a' }}>Your retirement corpus target is fully met — no additional SIP required.</span>
                                    </>
                                ) : (
                                    <>
                                        Your retirement investments are projected at <b>₹{formatNumberToIndianUnits(retInvProjected)}</b> and a liquid assets surplus of <b>₹{formatNumberToIndianUnits(liquidSurplus)}</b> — aggregating to a net value of <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b> against a retirement target of <b>{formatNumberToIndianUnits(targetCorpus)}</b>. A gap of <b style={{ color: '#dc2626' }}>{formatNumberToIndianUnits(correctedGap)}</b> exists. An additional SIP of <b>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</b> is recommended.
                                    </>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className={`${styles.planSummaryCard} pdf-atomic`}>

                        <div className={styles.planSummaryHeader}>
                            <div className={styles.planSummaryTitle}>📋 PLAN SUMMARY — {(
                                userData?.clientsDetails?.client_name ||
                                JSON.parse(localStorage.getItem('userData') || '{}')?.client_name ||
                                'CLIENT'
                            ).toUpperCase()}</div>
                            <div className={styles.planSummarySubtitle}>
                                Prepared by {
                                    userData?.clientsDetails?.spoc_rm_name ||
                                    userData?.clientsDetails?.rm_name ||
                                    localStorage.getItem('rm_name') ||
                                    (() => {
                                        try {
                                            return userData?.clientsDetails?.rm_details
                                                ? JSON.parse(userData.clientsDetails.rm_details).name
                                                : null;
                                        } catch { return null; }
                                    })() ||
                                    JSON.parse(localStorage.getItem('userData') || '{}')?.spoc_rm_name ||
                                    JSON.parse(localStorage.getItem('userData') || '{}')?.rm_name ||
                                    'Advisor'
                                } ({userData?.clientsDetails?.spoc_rm || userData?.clientsDetails?.rm_code || ''}) | {formatDate(userData?.clientsDetails?.created_at)}
                            </div>
                        </div>
                        <div className={styles.planSummaryContent}>
                            <p>
                                Client (Age <b>{userData?.clientsDetails?.age}</b>) is planning to retire at <b>{userData?.clientsDetails?.year_of_retirement}</b>, with a life expectancy of <b>{userData?.clientsDetails?.life_expectancy} years</b> — leaving <b>{userData?.planDetails?.YearsUnitilRetirement} years to build</b> the corpus and <b>{userData?.clientsDetails?.life_expectancy - userData?.clientsDetails?.year_of_retirement} years in retirement</b>. Current monthly expenses of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.clientsDetails.monthly_expenses))}</b> will grow to <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementExpanceRYMonthly))}</b>/mo at retirement (@ {userData?.clientsDetails?.inflation_rate}% inflation).
                            </p>
                            <p>
                                The <b>Retirement Target Corpus</b> is <b>{formatNumberToIndianUnits(targetCorpus)}</b>. Current investments of <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.totalInvestments))}</b> (Ret: ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.RetirementInvestments))}, Liquid: ₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))}) are projected to grow to <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                {userData.planDetails.shortageRYType === 'surplus'
                                    ? <> — <span style={{ color: '#16a34a' }}>exceeding the target with a surplus of <b>₹{formatNumberToIndianUnits(correctedSurplus)}</b>. No additional investment needed. ✓</span></>
                                    : <> — leaving a <b>gap of {formatNumberToIndianUnits(correctedGap)}</b> to be addressed.</>
                                }
                            </p>
                            <p>
                                {userData?.investmentDetails?.goals?.length > 0 ? (
                                    <span>
                                        <b>{userData.investmentDetails.goals.length} Life Goal{userData.investmentDetails.goals.length > 1 ? 's' : ''}</b> have been mapped:&nbsp;
                                        {userData.investmentDetails.goals.map((goal, idx) => {
                                            const goalIconMap = { 'Child Education': '🎓', 'Child Marriage': '💍', 'Home Purchase': '🏠', 'Vehicle': '🚗', 'Vacation': '✈️', 'Other Goals': '🎯' };
                                            const icon = goalIconMap[goal.goal_type] || '🎯';
                                            const name = goal.goal_name || goal.child_name || '';
                                            const goalKey = Object.keys(goalsData).find(k => goalsData[k].goals === goal);
                                            const isFulfilled = goalKey ? checkForNullOrNaN(goalsData[goalKey].shortage) < 1 : false;
                                            return (
                                                <span key={idx}>
                                                    {idx > 0 && ', '}
                                                    {icon} {goal.goal_type}{name ? ` — ${name}` : ''} ({goal.goal_year}{isFulfilled ? ' — Fulfilled ✓' : ''})
                                                </span>
                                            );
                                        })}
                                    </span>
                                ) : "No specific goals have been mapped in this plan."}
                            </p>
                        </div>
                        <div className={`${styles.planSummaryBadges} pdf-atomic`}>
                            <div className={styles.badgeItem}>🎯 Target Corpus {formatNumberToIndianUnits(targetCorpus)}</div>
                            <div className={styles.badgeItem}>📈 Projected ₹{formatNumberToIndianUnits(projectedTotalCorpus)}</div>
                            <div className={styles.badgeItem}>
                                {userData.planDetails.shortageRYType === 'surplus'
                                    ? '✅ No Additional SIP Required'
                                    : `📊 New SIP Recommended ₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo`}
                            </div>
                            <div className={styles.badgeItem}>
                                {userData.planDetails.shortageRYType === 'surplus'
                                    ? `🟢 Surplus: ₹${formatNumberToIndianUnits(correctedSurplus)}`
                                    : `⚠️ Status Gap: ${formatNumberToIndianUnits(correctedGap)}`}
                            </div>
                        </div>
                    </div>

                </div>
                {/* PAGE 1 ENDS HERE */}


                <div className={`pdf-page-two-container pdf-page-two ${styles.pdfPageWrapper}`}>

                    <div className={styles.recommendedSipCard}>
                        <div className={styles.recommendedSipTitle}>📊 RECOMMENDED SIP — GOALS &amp; RETIREMENT CORPUS</div>
                        {(() => {
                            // Goals strictly AFTER retirement year are excluded from this table entirely —
                            // neither shown as their own row nor folded into the Retirement Corpus SIP.
                            // The Retirement Corpus row mirrors correctedSIPMonthly, same as the
                            // Retirement Corpus Analysis card.
                            const retirementCalendarYear = new Date().getFullYear()
                                - (userData?.clientsDetails?.age || 0)
                                + (userData?.clientsDetails?.year_of_retirement || 0);

                            const sipTableGoalEntries = Object.entries(goalsData || {})
                                .filter(([, data]) => (data.goals?.goal_year || 0) <= retirementCalendarYear)
                                .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0));

                            const postRetirementGoalNames = Object.entries(goalsData || {})
                                .filter(([, data]) => (data.goals?.goal_year || 0) > retirementCalendarYear)
                                .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0))
                                .map(([, data]) => data.goals?.goal_name || data.goals?.child_name || data.goals?.goal_type || 'Goal');

                            const retirementCorpusLabel = postRetirementGoalNames.length > 0
                                ? `Retirement Corpus + ${formatList(postRetirementGoalNames)}`
                                : 'Retirement Corpus (additional)';

                            const totalSipMonthly = Math.round(
                                correctedSIPMonthly +
                                (userData?.investmentDetails?.goals?.length > 0
                                    ? sipTableGoalEntries.reduce((acc, [, curr]) => acc + (checkForNullOrNaN(curr.additionalSavings) > 0 ? curr.additionalSavings : 0), 0)
                                    : 0)
                            );

                            return (
                                <table className={styles.sipTable}>
                                    <thead>
                                        <tr>
                                            <th>GOAL / PURPOSE</th>
                                            <th>PERIOD</th>
                                            <th style={{ textAlign: "center" }}>STEP-UP</th>
                                            <th style={{ textAlign: "right" }}>MONTHLY SIP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userData?.investmentDetails?.goals?.length > 0 && sipTableGoalEntries.length > 0 ? (
                                            sipTableGoalEntries.map(([key, data], index) => {
                                                const isFulfilled = checkForNullOrNaN(data.shortage) < 1;
                                                const goalIconMap = { 'Child Education': '🎓', 'Child Marriage': '💍', 'Home Purchase': '🏠', 'Vehicle': '🚗', 'Vacation': '✈️', 'Other Goals': '🎯' };
                                                const icon = goalIconMap[data.goals?.goal_type] || '🎯';
                                                const name = data.goals?.goal_name || data.goals?.child_name || 'N/A';
                                                return (
                                                    <tr key={index}>
                                                        <td><span style={{ marginRight: '6px' }}>{icon}</span>{data.goals?.goal_type} — {name}</td>
                                                        <td>{isFulfilled ? data.goals?.goal_year : `Now → ${data.goals?.goal_year}`}</td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            {(() => {
                                                                const stepUp = Number(data.goals?.stepup_sip || data.goals?.step_up || data.goals?.GrowthRate || 0);
                                                                return stepUp > 0 ? `${stepUp}% p.a.` : '—';
                                                            })()}
                                                        </td>
                                                        <td style={{ textAlign: "right", color: isFulfilled ? "#15803d" : "inherit", fontWeight: isFulfilled ? "700" : "500" }}>
                                                            {isFulfilled
                                                                ? "Fulfilled ✓"
                                                                : `₹${Intl.NumberFormat('en-IN').format(Math.round(checkForNullOrNaN(data.additionalSavings)))}`
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right", color: "#15803d", fontStyle: "italic", fontWeight: "700", padding: "1rem 0" }}>
                                                    <span style={{ marginRight: '5px' }}>✓</span> No goals added
                                                </td>
                                            </tr>
                                        )}
                                        <tr className={styles.sipTableRowHighlighted}>
                                            <td><span style={{ marginRight: '8px' }}>🏦</span> {retirementCorpusLabel}</td>
                                            <td>{userData.planDetails.shortageRYType === 'surplus' ? '—' : `Now → ${new Date().getFullYear() + checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)}`}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                {(() => {
                                                    try {
                                                        const inv = userData?.investmentDetails;
                                                        const annualInc = Number(
                                                            inv?.annual_increase_existing_investment ||
                                                            inv?.annual_increase ||
                                                            0
                                                        );
                                                        return annualInc > 0 ? `${annualInc}% p.a.` : '—';
                                                    } catch { return '—'; }
                                                })()}
                                            </td>
                                            <td style={{ textAlign: "right", color: userData.planDetails.shortageRYType === 'surplus' ? '#16a34a' : 'inherit', fontWeight: userData.planDetails.shortageRYType === 'surplus' ? '700' : '500' }}>
                                                {userData.planDetails.shortageRYType === 'surplus'
                                                    ? 'Not Required ✓'
                                                    : `₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}`}
                                            </td>
                                        </tr>
                                        <tr className={styles.sipTableTotalRow}>
                                            <td colSpan="3" className={styles.sipTotalLabel}>Total New SIP Recommended</td>
                                            <td className={styles.sipTotalValue}>
                                                {userData.planDetails.shortageRYType === 'surplus' && totalSipMonthly <= 0
                                                    ? <span style={{ color: '#16a34a' }}>₹0/mo — No SIP Needed ✓</span>
                                                    : `₹${Intl.NumberFormat('en-IN').format(totalSipMonthly)}/mo`
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            );
                        })()}
                        <div className={styles.sipNote}>* Once a goal is achieved, that SIP amount is redirected to the next goal and ultimately to Retirement Corpus.</div>
                    </div>

                    {/* Investment Portfolio Table */}
                    <div className={styles.investmentDiv}>
                        <h3 className={styles.investmentHeading}>Investment Portfolio</h3>

                        <div className="pdf-atomic">
                            <table className={styles.newInvestmentTable}>
                                <thead>
                                    <tr>
                                        <th>INVESTMENT</th>
                                        <th>CURRENT HOLDING</th>
                                        <th>MONTHLY CONTRIBUTION</th>
                                        <th>RETURN RATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className={styles.newCategoryRow}>
                                        <td colSpan="4">
                                            <span className={`${styles.newCategoryDot} ${styles.newDotRed}`}></span>RETIREMENT INVESTMENTS
                                        </td>
                                    </tr>
                                    {[
                                        { label: 'EPF', holding: userData.investmentDetails.epf_holding, monthly: userData.investmentDetails.epf_monthly, rate: '8.25%' },
                                        { label: 'PPF', holding: userData.investmentDetails.ppf_holding, monthly: userData.investmentDetails.ppf_monthly, rate: '7.1%' },
                                        { label: 'VPF', holding: userData.investmentDetails.vpf_holding, monthly: userData.investmentDetails.vpf_monthly, rate: '8.25%' },
                                        { label: 'NPS', holding: userData.investmentDetails.nps_holding, monthly: userData.investmentDetails.nps_monthly, rate: '10%' },
                                        { label: 'Other Ret.', holding: userData.investmentDetails.other_retirement_investment_holding, monthly: userData.investmentDetails.other_retirement_investment_monthly, rate: '8%' },
                                    ].map((row, i) => (
                                        <tr key={i} className={styles.newRetirementRow}>
                                            <td>{row.label}</td>
                                            <td>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(row.holding))}</td>
                                            <td>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(row.monthly))}</td>
                                            <td>{row.rate}</td>
                                        </tr>
                                    ))}
                                    <tr className={styles.newInvestmentTotalRow}>
                                        <td>Total Retirement</td>
                                        <td>₹ {Intl.NumberFormat('en-IN').format(
                                            checkForNullOrNaN(userData.investmentDetails.epf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.ppf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.vpf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.nps_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_holding)
                                        )}</td>
                                        <td>₹ {Intl.NumberFormat('en-IN').format(
                                            checkForNullOrNaN(userData.investmentDetails.epf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.ppf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.vpf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.nps_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.other_retirement_investment_monthly)
                                        )}</td>
                                        <td>—</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="pdf-atomic">
                            <table className={styles.newInvestmentTable}>
                                <thead>
                                    <tr>
                                        <th>INVESTMENT</th>
                                        <th>CURRENT HOLDING</th>
                                        <th>MONTHLY CONTRIBUTION</th>
                                        <th>RETURN RATE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className={styles.newCategoryRow}>
                                        <td colSpan="4">
                                            <span className={`${styles.newCategoryDot} ${styles.newDotBlue}`}></span>LIQUID / NON-RETIREMENT
                                        </td>
                                    </tr>
                                    {[
                                        { label: 'Mutual Funds', holding: userData.investmentDetails.mf_holding, monthly: userData.investmentDetails.mf_monthly, rate: '12%' },
                                        { label: 'Stocks', holding: userData.investmentDetails.stocks_holding, monthly: userData.investmentDetails.stocks_monthly, rate: '12%' },
                                        { label: 'Bonds', holding: userData.investmentDetails.bonds_holding, monthly: userData.investmentDetails.bonds_monthly, rate: '8%' },
                                        { label: 'FD / RD', holding: userData.investmentDetails.fdrd_holding, monthly: userData.investmentDetails.fdrd_monthly, rate: '7%' },
                                        { label: 'Other Non Ret.', holding: userData.investmentDetails.other_non_retirement_investment_holding, monthly: userData.investmentDetails.other_non_retirement_investment_monthly, rate: '10%' },
                                    ].map((row, i) => (
                                        <tr key={i} className={styles.newLiquidRow}>
                                            <td>{row.label}</td>
                                            <td>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(row.holding))}</td>
                                            <td>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(row.monthly))}</td>
                                            <td>{row.rate}</td>
                                        </tr>
                                    ))}
                                    <tr className={styles.newInvestmentTotalRow}>
                                        <td>Total Non-Retirement</td>
                                        <td>₹ {Intl.NumberFormat('en-IN').format(
                                            checkForNullOrNaN(userData.investmentDetails.mf_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.stocks_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.bonds_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.fdrd_holding) +
                                            checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_holding)
                                        )}</td>
                                        <td>₹ {Intl.NumberFormat('en-IN').format(
                                            checkForNullOrNaN(userData.investmentDetails.mf_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.stocks_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.bonds_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.fdrd_monthly) +
                                            checkForNullOrNaN(userData.investmentDetails.other_non_retirement_investment_monthly)
                                        )}</td>
                                        <td>—</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>

                {/* PAGE 2 ENDS HERE */}



                <div className={`pdf-page-three-container pdf-page-three ${styles.pdfPageWrapper}`}>
                    {/* Capital Receipts */}
                    <h3 className={styles.investmentHeading}>Capital Receipts</h3>
                    <div className={`${styles.sectionContentBox} pdf-atomic`} style={{ marginBottom: isSingleGoal ? '0.75rem' : '2rem' }}>
                        <table className={styles.newReceiptsTable}>
                            <thead>
                                <tr>
                                    <th>DESCRIPTION</th>
                                    <th>YEAR</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userData?.investmentDetails?.capital_receipts?.length > 0 ? (
                                    userData.investmentDetails.capital_receipts.map((receipt, index) => (
                                        <tr key={index}>
                                            <td>{receipt.description || receipt.CRName || 'N/A'}</td>
                                            <td>{receipt.year || receipt.CRYear || 'N/A'}</td>
                                            <td>₹ {Intl.NumberFormat('en-IN').format(checkForNullOrNaN(receipt.amount))}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className={styles.newReceiptsEmpty}>No capital receipts added</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>



                {/* Analysis */}

                <div className={styles.pdfPageWrapper}>
                    {/* Retirement Analysis */}
                    <h3 className={styles.investmentHeading}>Retirement Analysis</h3>
                    <div className={`${styles.sectionContentBox} pdf-atomic`} style={{ marginBottom: isSingleGoal ? '0.75rem' : '2rem' }}>
                        <p className={styles.newRetirementSubText} style={isSingleGoal ? { margin: '0.2rem 0 0.5rem' } : {}}>
                            {checkForNullOrNaN(userData.planDetails.YearsUnitilRetirement)} Years to Retirement • {userData.clientsDetails.life_expectancy - userData.clientsDetails.year_of_retirement} Years in Retirement
                        </p>
                        <div className={styles.newSummaryAnalysisGrid} style={isSingleGoal ? { margin: '0.5rem 0' } : {}}>
                            <div className={styles.newSummaryAnalysisCard}>
                                <div className={styles.newSummaryAnalysisLabel}>TOTAL INVESTMENTS</div>
                                <div className={styles.newSummaryAnalysisValue}>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.totalInvestments))}</div>
                                <div className={styles.newSummaryAnalysisSplit}>
                                    Ret: <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.RetirementInvestments))}</b> | Liquid: <b>₹{formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.NonRetirementInvestments))}</b>
                                </div>
                            </div>
                            <div className={styles.newSummaryAnalysisCard}>
                                <div className={styles.newSummaryAnalysisLabel}>TOTAL MONTHLY SIP</div>
                                <div className={styles.newSummaryAnalysisValue}>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.TotalContributions))}</div>
                                <div className={styles.newSummaryAnalysisSplit}>
                                    Ret: <b>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.RetirementContributions))}</b> | Liquid: <b>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(userData.planDetails.NonRetirementContributions))}</b>
                                </div>
                            </div>
                            <div className={styles.newSummaryAnalysisCard}>
                                <div className={styles.newSummaryAnalysisLabel}>RETIREMENT TARGET CORPUS</div>
                                <div className={`${styles.newSummaryAnalysisValue} ${styles.newSummaryAnalysisValueOrange}`}>
                                    {formatNumberToIndianUnits(checkForNullOrNaN(userData.planDetails.retirementCorpusRY))}
                                </div>
                                <div className={styles.newSummaryAnalysisSplit}>
                                    Projected: <b>₹{formatNumberToIndianUnits(projectedTotalCorpus)}</b>
                                    {userData.planDetails.shortageRYType === 'surplus' && <span style={{ color: '#16a34a' }}> ✓ Surplus</span>}
                                </div>
                            </div>
                        </div>
                        <div className={styles.newSummaryAnalysisFooter}>
                            Retirement Goal: <span className={styles.newGoalPercent}>{retPercent >= 100 ? '100%+ ✓' : `${retPercent}%`}</span>
                            {' '}— Projected ₹{formatNumberToIndianUnits(projectedTotalCorpus)} vs Target {formatNumberToIndianUnits(targetCorpus)}
                            {userData.planDetails.shortageRYType === 'surplus' && <span style={{ color: '#16a34a', marginLeft: '8px' }}>— Target fully met ✓</span>}
                        </div>
                    </div>

                    {/* Goal-Wise Analysis  */}

                    {Object.keys(goalsData).length > 0 && (
                        <div className={isSingleGoal ? '' : styles.newSectionCard}>

                            <h3 className={styles.investmentHeading}>Goal-wise Analysis</h3>
                            {Object.entries(goalsData)
                                .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0))
                                .map(([key, data], index) => {
                                    const goalIconMap = { 'Child Education': '🎓', 'Child Marriage': '💍', 'Home Purchase': '🏠', 'Vehicle': '🚗', 'Vacation': '✈️', 'Other Goals': '🎯' };
                                    const icon = goalIconMap[data.goals?.goal_type] || '🎯';
                                    const isFulfilled = checkForNullOrNaN(data.shortage) < 1;
                                    const GoalYear = data.goals?.goal_year || 0;
                                    const currentYear = new Date().getFullYear();
                                    const yrsAway = Math.max(0, GoalYear - currentYear);
                                    const retRate = Number(userData?.planDetails?.cashflowParams?.weightedPreROR) || 12;
                                    const inflation = data.goals?.expected_inflation || userData?.clientsDetails?.inflation_rate || 5;
                                    const capitalReceiptsList = userData?.investmentDetails?.capital_receipts || [];
                                    const hasCR = capitalReceiptsList.length > 0;
                                    const gridCols = hasCR ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)';
                                    const taggedFV = checkForNullOrNaN(data.taggedInvestmentsFV) + checkForNullOrNaN(data.monthlyInvestmentFV);
                                    const monthlySIP = Math.round(checkForNullOrNaN(data.additionalSavings));
                                    const alloc = getAllocationForGoal(yrsAway, retRate);
                                    const crFV = checkForNullOrNaN(data.capitalReceiptFV);
                                    const surplus = isFulfilled
                                        ? Math.max(0, taggedFV + crFV - checkForNullOrNaN(data.amountRequired))
                                        : 0;

                                    return (
                                        <div key={key} className={`${styles.goalCard} pdf-atomic`}>
                                            <div className={styles.goalCardHeader} style={isSingleGoal ? { padding: '8px 14px' } : {}}>
                                                <div>
                                                    <div className={styles.goalCardTitle}>{icon} {data.goals?.goal_type} — {data.goals?.goal_name || data.goals?.child_name}</div>
                                                    <div className={styles.goalCardMeta}>
                                                        <span>Target Year: <b>{GoalYear}</b></span>
                                                        <span className={styles.goalCardMetaDivider}>|</span>
                                                        <span>{yrsAway} yrs away</span>
                                                        <span className={styles.goalCardMetaDivider}>|</span>
                                                        <span>Return: <b>{retRate.toFixed(2)}%</b></span>
                                                        <span className={styles.goalCardMetaDivider}>|</span>
                                                        <span>Inflation: <b>{inflation}%</b></span>
                                                    </div>
                                                </div>
                                                <span className={styles.goalCardBadge}>{isFulfilled ? 'Funded ✓' : 'Shortfall ⚠️'}</span>
                                            </div>

                                            <div className={styles.goalCardStatsGrid} style={{ gridTemplateColumns: gridCols }}>
                                                <div className={styles.goalStatBox} style={isSingleGoal ? { padding: '6px 12px' } : {}}>
                                                    <div className={styles.goalStatBoxLabel}>Inflation-Adj. Target</div>
                                                    <div className={styles.goalStatBoxValue}>{formatNumberToIndianUnits(checkForNullOrNaN(data.amountRequired))}</div>
                                                </div>
                                                <div className={styles.goalStatBox} style={isSingleGoal ? { padding: '6px 12px' } : {}}>
                                                    <div className={styles.goalStatBoxLabel}>Tagged Investments (FV)</div>
                                                    <div className={styles.goalStatBoxValue}>{taggedFV > 0 ? formatNumberToIndianUnits(taggedFV) : '₹0'}</div>
                                                </div>
                                                {hasCR && (
                                                    <div className={styles.goalStatBox} style={isSingleGoal ? { padding: '6px 12px' } : {}}>
                                                        <div className={styles.goalStatBoxLabel}>Mapped CR / Carried Surplus (FV)</div>
                                                        <div className={styles.goalStatBoxValue}>{crFV > 0 ? formatNumberToIndianUnits(crFV) : '₹0'}</div>
                                                    </div>
                                                )}
                                                <div className={styles.goalStatBox} style={isSingleGoal ? { padding: '6px 12px', borderRight: 'none' } : { borderRight: 'none' }}>
                                                    <div className={styles.goalStatBoxLabel}>{isFulfilled ? 'Surplus' : 'Shortfall'}</div>
                                                    <div className={styles.goalStatBoxValue}>
                                                        {isFulfilled
                                                            ? `₹${Intl.NumberFormat('en-IN').format(Math.round(surplus))}`
                                                            : formatNumberToIndianUnits(checkForNullOrNaN(Math.abs(data.shortage)))
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={styles.goalCardFooter} style={isSingleGoal ? { padding: '8px 14px' } : {}}>
                                                <span>Total Projected: <b>{formatNumberToIndianUnits(checkForNullOrNaN(data.amountRequired))}</b></span>
                                                <span className={styles.goalCardFooterDivider}>|</span>
                                                {isFulfilled ? (
                                                    <span>Surplus cascades to next goal / retirement</span>
                                                ) : (
                                                    <span>Additional SIP: ₹{Intl.NumberFormat('en-IN').format(monthlySIP)}/mo OR Lumpsum: {formatNumberToIndianUnits(checkForNullOrNaN(data.addinonalLumsum))}</span>
                                                )}
                                            </div>

                                            {/* ── CR detail row ── */}
                                            {hasCR && (() => {
                                                const CRExpReturn = userData?.investmentDetails?.cr_exp_return
                                                    ? Number(userData.investmentDetails.cr_exp_return) / 100
                                                    : 0.06;

                                                // Total cumulative FV of all CRs at goal year (only those before or at goal year)
                                                const crSnapshot = data.crRemainingSnapshot || [];
                                                const totalCRFVAtGoalYear = capitalReceiptsList.reduce((sum, r, i) => {
                                                    const crYear = Number(r.year || r.CRYear || 0);
                                                    const remainingPrincipal = (crSnapshot[i] !== undefined && crSnapshot[i] !== null)
                                                        ? crSnapshot[i]
                                                        : Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''));
                                                    if (crYear <= GoalYear) {
                                                        const yrs = Math.max(0, GoalYear - crYear);
                                                        return sum + remainingPrincipal * Math.pow(1 + CRExpReturn, yrs);
                                                    }
                                                    return sum;
                                                }, 0);

                                                // Amount mapped against this goal from capital receipts
                                                const crMappedToGoal = checkForNullOrNaN(crFV);

                                                // Only show new format if capital receipts were actually used for this goal
                                                const crWasUsed = crMappedToGoal > 0;

                                                return (
                                                    <div style={{
                                                        padding: '8px 18px 10px', background: '#fafafa',
                                                        borderTop: '1px dashed #e2e8f0', fontSize: '0.78rem',
                                                        color: '#555', lineHeight: '1.7'
                                                    }}>
                                                        {crWasUsed ? (
                                                            <>
                                                                {(() => {
                                                                    const cascadedLiquidSurplus = Math.max(0, crMappedToGoal - totalCRFVAtGoalYear);
                                                                    const crSurplus = Math.max(0, Math.round(totalCRFVAtGoalYear) - Math.round(crMappedToGoal));

                                                                    const parts = [
                                                                        { label: 'Goal-year capital receipts', value: formatNumberToIndianUnits(totalCRFVAtGoalYear) },
                                                                        { label: 'Cascaded liquid surplus', value: formatNumberToIndianUnits(cascadedLiquidSurplus) },
                                                                        { label: 'Mapped to goal', value: formatNumberToIndianUnits(crMappedToGoal) },
                                                                        ...(Math.round(crSurplus) > 0 ? [{ label: 'Residual surplus', value: formatNumberToIndianUnits(crSurplus) }] : []),
                                                                    ];

                                                                    return parts.map((part, i) => (
                                                                        <span key={part.label}>
                                                                            {i > 0 && <span style={{ margin: '0 8px', opacity: 0.5 }}>|</span>}
                                                                            {part.label}: <b>₹{part.value}</b>
                                                                        </span>
                                                                    ));
                                                                })()}
                                                            </>
                                                        ) : (
                                                            <>
                                                                🪙 {capitalReceiptsList.map((r, i) => {
                                                                    const crYear = Number(r.year || r.CRYear || 0);
                                                                    const amt = Number(String(r.amount || r.CRAmt || 0).replace(/,/g, ''));
                                                                    const isAfterGoal = crYear > GoalYear;
                                                                    const yrs = Math.max(0, GoalYear - crYear);
                                                                    const fv = isAfterGoal ? amt : amt * Math.pow(1 + CRExpReturn, yrs);
                                                                    return (
                                                                        <span key={i}>
                                                                            {i > 0 && '; '}
                                                                            "{r.description || r.CRName}" ({crYear}) —{' '}
                                                                            {formatNumberToIndianUnits(amt)}{' '}
                                                                            {isAfterGoal
                                                                                ? <span style={{ color: '#f97316' }}>
                                                                                    ⚠️ arrives after goal year — will apply to future goals
                                                                                </span>
                                                                                : <>invested, grows to {formatNumberToIndianUnits(fv)} by {GoalYear}</>
                                                                            }
                                                                        </span>
                                                                    );
                                                                })}
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })()}
                                            <div className={styles.goalCardAllocPanel} style={isSingleGoal ? { padding: '10px 14px' } : {}}>
                                                <div className={styles.goalCardAllocTitle}>Recommended Allocation</div>
                                                {isFulfilled ? (
                                                    <div className={styles.goalCardAllocCallout}>Goal is fully funded — no additional SIP required ✓</div>
                                                ) : monthlySIP > 0 ? (
                                                    <>
                                                        <div className={styles.goalCardAllocCallout}>Invest <b>₹{Intl.NumberFormat('en-IN').format(monthlySIP)}/mo</b> across this mix</div>
                                                        <div className={styles.goalCardAllocChips}>
                                                            {[
                                                                { label: 'Equity', pct: alloc.Equity },
                                                                { label: 'Debt', pct: alloc.Bond },
                                                                { label: 'Cash', pct: alloc.Cash },
                                                                { label: 'Gold', pct: alloc.Gold },
                                                                { label: 'Silver', pct: alloc.Silver },
                                                            ].filter(c => c.pct > 0).sort((a, b) => b.pct - a.pct).map(c => (
                                                                <div key={c.label} className={styles.allocChip}>
                                                                    <span className={styles.allocChipLabel}>{c.label}</span>
                                                                    <span className={styles.allocChipValue}>{c.pct}%</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}

                    {Object.keys(goalsData).length > 0 && (
                        <div className={isSingleGoal ? '' : styles.newSectionCard}>
                            <div className={`${styles.sipFlowBox} pdf-atomic`} style={isSingleGoal ? { padding: '12px 16px' } : {}}>
                                <div>
                                    <div className={styles.sipFlowTitle} style={isSingleGoal ? { marginBottom: '4px' } : {}}>📊 SIP Redirection Flow</div>
                                    <div className={styles.sipFlowDesc} style={isSingleGoal ? { marginBottom: '8px', fontSize: '0.75rem' } : {}}>Each goal's SIP starts today. Once a goal is achieved, that SIP amount is redirected to the next goal, reducing its required SIP.</div>
                                </div>
                                {Object.entries(goalsData)
                                    .sort((a, b) => (Number(a[1].goals?.goal_year) || 0) - (Number(b[1].goals?.goal_year) || 0))
                                    .map(([key, data]) => {
                                        const isFulfilled = checkForNullOrNaN(data.shortage) < 1;
                                        const name = data.goals?.goal_name || data.goals?.child_name || '';
                                        const goalType = data.goals?.goal_type || 'Goal';
                                        const surplusAmt = isFulfilled ? Math.max(0, checkForNullOrNaN(data.amountRequired) - checkForNullOrNaN(data.amountRequired)) : 0;
                                        return (
                                            <div key={key} className={`${styles.sipFlowRow} pdf-atomic`} style={isSingleGoal ? { padding: '6px 0' } : {}}>
                                                <span className={styles.sipFlowIcon}>🪙</span>
                                                <span className={styles.sipFlowText}>
                                                    Surplus from {isFulfilled ? 'fulfilled' : 'unfulfilled'} goals ({goalType}{name ? ` — ${name}` : ''}) = <b>₹{Intl.NumberFormat('en-IN').format(Math.round(surplusAmt))}</b> — applied to reduce retirement corpus gap
                                                </span>
                                            </div>
                                        );
                                    })}
                                <div className={`${styles.sipFlowRow} pdf-atomic`} style={isSingleGoal ? { padding: '6px 0', paddingTop: '8px' } : {}}>
                                    <span className={styles.sipFlowIcon}>♟️</span>
                                    <span className={styles.sipFlowText}>
                                        Post all goals, total redirected SIP of{' '}
                                        <b>₹{Intl.NumberFormat('en-IN').format(Math.round(
                                            Object.values(goalsData).reduce((sum, d) => sum + (checkForNullOrNaN(d.additionalSavings) <= 0 ? 0 : checkForNullOrNaN(d.additionalSavings)), 0)
                                        ))}/mo</b>{' '}
                                        fully flows into <b>Retirement Corpus</b>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {!isSingleGoal && renderRetirementCorpusAnalysis()}
                    {/* Action Required Box */}
                </div>

                {/* Modernized Action Plan Section */}
                <div className={`${styles.actionPlan} ${styles.pdfPageWrapper}`} style={isSingleGoal ? { margin: '0.5rem 2rem 0' } : {}}>
                    {isSingleGoal && renderRetirementCorpusAnalysis()}


                    {userData?.planDetails?.shortageRYType === 'surplus' ? (
                        // ── SURPLUS CASE ──
                        <div className="pdf-atomic" style={isSingleGoal ? { marginBottom: '1.25rem' } : {}}>
                            <h3 className={styles.investmentHeading}>Action Plan</h3>
                            <div className={styles.surplusBox} style={isSingleGoal ? { padding: '16px 20px', borderRadius: '12px' } : {}}>
                                <div className={styles.surplusBoxIcon}>🎉</div>
                                <div className={styles.surplusBoxTitle}>
                                    No Additional SIP Required
                                </div>
                                <div className={styles.surplusBoxText}>
                                    Your retirement corpus target of <b>{formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY))}</b> is fully covered.<br />
                                    Projected corpus of <b>₹{formatNumberToIndianUnits(
                                        checkForNullOrNaN(userData?.planDetails?.totalAllRetirement?.retirement)
                                        + checkForNullOrNaN(userData?.planDetails?.totalAllRetirement?.retirementMonthly)
                                        + liquidSurplus
                                        + checkForNullOrNaN(unallocatedCapitalReceiptsFV)
                                    )}</b> exceeds the target with a surplus of <b>₹{formatNumberToIndianUnits(
                                        liquidSurplus
                                    )}</b>.<br />
                                    Your financial plan is strong and adequately supports your future requirements.
                                </div>
                            </div>
                        </div>
                    ) : (
                        // ── SHORTAGE CASE ──
                        <div className="pdf-atomic" style={isSingleGoal ? { marginBottom: '1.25rem' } : {}}>
                            <h3 className={styles.investmentHeading}>Action Plan</h3>
                            <p className={styles.actionPlanSubtitle}>
                                Choose one of the two paths below to rebalance your portfolio and reach your ₹ {formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.retirementCorpusRY))} target.
                            </p>
                            <div className={`${styles.actionPlanGrid} pdf-atomic`}>
                                {/* Plan A */}
                                <div className={`${styles.apCard} ${styles.apCardPlanA}`}>
                                    <div className={styles.apCardHeader}>📈 PLAN A — SIP (RECOMMENDED)</div>
                                    <table className={styles.apTable}>
                                        <thead>
                                            <tr><th>PURPOSE</th><th style={{ textAlign: 'right' }}>AMOUNT</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '8px' }}>account_balance</span> Retirement SIP</td>
                                                <td style={{ textAlign: 'right' }}>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</td>
                                            </tr>
                                            <tr className={styles.apTableTotalRow}>
                                                <td>Total New SIP / Month</td>
                                                <td style={{ textAlign: 'right' }}>₹{Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className={styles.apFooterNote}>SIP amounts redirect to Retirement Corpus as each goal is achieved.</div>
                                </div>
                                {/* Plan B */}
                                <div className={`${styles.apCard} ${styles.apCardPlanB}`}>
                                    <div className={styles.apCardHeader}>💰 PLAN B — LUMPSUM</div>
                                    <table className={styles.apTable}>
                                        <thead>
                                            <tr><th>GOAL</th><th style={{ textAlign: 'right' }}>LUMPSUM NOW</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '8px' }}>account_balance</span> Retirement Gap</td>
                                                <td style={{ textAlign: 'right' }}>{formatNumberToIndianUnits(correctedLumpsum)}</td>
                                            </tr>
                                            <tr className={styles.apTableTotalRow}>
                                                <td>Total Lumpsum Required</td>
                                                <td style={{ textAlign: 'right' }}>{formatNumberToIndianUnits(correctedLumpsum)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className={styles.apFooterNote}>Invest lumpsum today to fully close the retirement and goal gaps.</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Plan at a Glance Section */}
                    <div className={`${styles.glanceDiv} pdf-atomic`} style={isSingleGoal ? { marginTop: '20px' } : {}}>
                        <h3 className={styles.investmentHeading}>Plan at a Glance</h3>
                        <div className={styles.glanceMainCard} style={isSingleGoal ? { padding: '12px 14px' } : {}}>
                            <div className={styles.glanceCardsGrid} style={isSingleGoal ? { marginBottom: '8px', gap: '8px' } : {}}>
                                {/* Card 1: Retirement */}
                                <div className={`${styles.glanceCard} ${styles.glanceRetirement}`} style={isSingleGoal ? { padding: '8px 10px', gap: '0.2rem' } : {}}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>
                                            {userData?.planDetails?.shortageRYType === 'surplus' ? '✅' : '⚠️'}
                                        </span> RETIREMENT
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData?.planDetails?.shortageRYType === 'surplus' ? 'SURPLUS' : 'SHORTAGE'}
                                    </div>
                                    <div className={styles.glanceCardSub}>
                                        {userData?.planDetails?.shortageRYType === 'surplus'
                                            ? `+${formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.shortageRY))} ABOVE TARGET ✓`
                                            : `-${formatNumberToIndianUnits(checkForNullOrNaN(userData?.planDetails?.shortageRY))} BELOW TARGET`
                                        }
                                    </div>
                                </div>

                                {/* Card 2: Goals */}
                                <div className={`${styles.glanceCard} ${styles.glanceGoals}`} style={isSingleGoal ? { padding: '8px 10px', gap: '0.2rem' } : {}}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>✅</span> GOALS
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {fundedGoalsWithRetirement}/{totalGoalsWithRetirement} FUNDED
                                    </div>
                                    <div className={styles.glanceCardSub}>
                                        {shortGoalsWithRetirement === 0 ? "ALL GOALS ON TRACK" : `${shortGoalsWithRetirement} GOAL(s) NEED ATTENTION`}
                                    </div>
                                </div>

                                {/* Card 3: Insurance */}
                                <div className={`${styles.glanceCard} ${styles.glanceInsurance}`} style={isSingleGoal ? { padding: '8px 10px', gap: '0.2rem' } : {}}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>✅</span> INSURANCE
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        COVERED
                                    </div>
                                    <div className={styles.glanceCardSub}>
                                        TERM ✓ HEALTH ✓
                                    </div>
                                </div>

                                {/* Card 4: Action Needed */}
                                <div className={`${styles.glanceCard} ${styles.glanceAction}`} style={isSingleGoal ? { padding: '8px 10px', gap: '0.2rem' } : {}}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>📌</span> ACTION NEEDED
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData?.planDetails?.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>NOT REQUIRED ✓</span>
                                            : `₹${Intl.NumberFormat('en-IN').format(correctedSIPMonthly)}/mo`
                                        }
                                    </div>
                                    <div className={styles.glanceCardSub}>
                                        {userData?.planDetails?.shortageRYType === 'surplus' ? 'CORPUS TARGET ALREADY MET' : 'RETIREMENT SIP ONLY'}
                                    </div>
                                </div>
                                {/* Card 5: Lumpsum */}
                                <div className={`${styles.glanceCard} ${styles.glanceAction}`} style={isSingleGoal ? { padding: '8px 10px', gap: '0.2rem' } : {}}>
                                    <div className={styles.glanceCardHeader}>
                                        <span className={styles.glanceCardIcon}>💰</span> LUMPSUM OPTION
                                    </div>
                                    <div className={styles.glanceCardValue}>
                                        {userData?.planDetails?.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>NOT REQUIRED ✓</span>
                                            : formatNumberToIndianUnits(correctedLumpsum)
                                        }
                                    </div>
                                    <div className={styles.glanceCardSub}>
                                        {userData?.planDetails?.shortageRYType === 'surplus'
                                            ? 'CORPUS TARGET ALREADY MET'
                                            : 'ONE-TIME INVESTMENT TO CLOSE GAP'
                                        }
                                    </div>
                                </div>

                            </div>

                            {/* Recommended Allocation Section */}
                            <div className={styles.allocationSection} style={isSingleGoal ? { paddingTop: '8px', marginTop: '2px' } : {}}>
                                <div className={styles.allocationTitle}>
                                    Recommended Allocation
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: isSingleGoal ? '6px' : '12px', width: '100%' }}>
                                    <div className={styles.allocationBars} style={{ width: '100%' }}>
                                        {[
                                            { label: 'Equity', pct: equityPct, labelClass: styles.barLabelBlue, percentClass: styles.barPercentBlue, barClass: styles.progressBlue },
                                            { label: 'Debt', pct: debtPct, labelClass: styles.barLabelGreen, percentClass: styles.barPercentGreen, barClass: styles.progressGreen },
                                            { label: 'Cash', pct: cashPct, labelClass: styles.barLabelOrange, percentClass: styles.barPercentOrange, barClass: styles.progressOrange },
                                            { label: 'Gold', pct: goldPct, color: '#d97706', labelClass: styles.barLabelBlue, percentClass: styles.barPercentBlue },
                                            { label: 'Silver', pct: silverPct, color: '#94a3b8', labelClass: styles.barLabelBlue, percentClass: styles.barPercentBlue },
                                            { label: 'ST Debt', pct: stDebtPct, color: '#9ca3af', labelClass: styles.barLabelBlue, percentClass: styles.barPercentBlue },

                                        ]
                                            .filter(b => b.pct > 0)
                                            .sort((a, b) => b.pct - a.pct)
                                            .map(b => (
                                                <div key={b.label} className={styles.allocationBarItem}>
                                                    {b.labelClass ? (
                                                        <span className={b.labelClass}>{b.label}</span>
                                                    ) : (
                                                        <span style={{ color: b.labelColor || b.color, width: '60px', fontSize: '0.82rem', fontWeight: '600', flexShrink: 0 }}>{b.label}</span>
                                                    )}
                                                    <div className={styles.progressBarWrapper} style={{ flex: 1 }}>
                                                        <div
                                                            className={b.barClass ? `${styles.progressBar} ${b.barClass}` : styles.progressBar}
                                                            style={{ width: `${b.pct}%`, ...(b.color ? { background: b.color } : {}) }}
                                                        ></div>
                                                    </div>
                                                    {b.percentClass ? (
                                                        <span className={b.percentClass}>{b.pct}%</span>
                                                    ) : (
                                                        <span style={{ color: b.labelColor || b.color, width: '40px', textAlign: 'right', fontSize: '0.82rem', fontWeight: '700' }}>{b.pct}%</span>
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                    <div className={styles.allocationCallout} style={isSingleGoal ? { marginTop: '4px', padding: '4px 8px' } : {}}>
                                        {userData?.planDetails?.shortageRYType === 'surplus'
                                            ? <span style={{ color: '#16a34a' }}>✓ NO ADDITIONAL INVESTMENT NEEDED — CORPUS TARGET ALREADY MET</span>
                                            : <>Invest <b>₹{Intl.NumberFormat('en-IN').format(Math.round(checkForNullOrNaN(userData?.planDetails?.additionalSavRqd?.monthly) + (userData?.investmentDetails?.goals?.length > 0 ? Object.values(goalsData || {}).reduce((acc, curr) => acc + curr.additionalSavings, 0) : 0)))}/mo</b> across this mix</>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {/* pdf-page-four — Insurance & Loans Section */}
                <div className={`pdf-page-four`} style={{ padding: '0' }}>
                    {(() => {
                        const recommendedTerm = checkForNullOrNaN(userData?.planDetails?.insurance?.li_si);
                        const recommendedHealth = checkForNullOrNaN(userData?.planDetails?.insurance?.hi_si);
                        const policies = userData.investmentDetails?.insurance_coverage || [];
                        const loans = userData.investmentDetails?.liabilities_loans || [];
                        const totalTermCoverage = policies.filter(p => p.type === 'Term Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                        const totalHealthCoverage = policies.filter(p => p.type === 'Health Insurance').reduce((s, p) => s + checkForNullOrNaN(p.coverage), 0);
                        const termGap = Math.max(0, recommendedTerm - totalTermCoverage);
                        const healthGap = Math.max(0, recommendedHealth - totalHealthCoverage);
                        const totalPremium = policies.reduce((s, p) => s + checkForNullOrNaN(p.premium), 0);
                        const totalOutstanding = loans.reduce((s, l) => s + checkForNullOrNaN(l.outstanding), 0);
                        const totalLoanAmt = loans.reduce((s, l) => s + checkForNullOrNaN(l.total), 0);
                        const totalEmi = loans.reduce((s, l) => s + checkForNullOrNaN(l.emi), 0);

                        return (
                            <div className={styles.insuranceLoansSection}>

                                {/* Insurance Coverage & Gap Analysis */}
                                <div className={styles.insuranceLoansBlock}>
                                    <h3 className={styles.investmentHeading}>Insurance Coverage &amp; Gap Analysis</h3>
                                    {/* Gap Summary Table */}
                                    <table className={styles.insTable}>
                                        <thead>
                                            <tr>
                                                {['TYPE', 'REQUIRED', 'EXISTING', 'GAP', 'STATUS'].map(h => (
                                                    <th key={h}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className={styles.insTypeLabel}>Term Insurance</div>
                                                    <div className={styles.insTypeSub}>PV of survivor expenses + loans</div>
                                                </td>
                                                <td className={styles.insReqValue}>{formatInsuranceValue(recommendedTerm)}</td>
                                                <td className={styles.insExistValue}>{totalTermCoverage > 0 ? formatInsuranceValue(totalTermCoverage) : 'Not added'}</td>
                                                <td className={termGap > 0 ? styles.insGapShort : styles.insGapCovered}>
                                                    {termGap > 0 ? formatInsuranceValue(termGap) : '✓ Covered'}
                                                </td>
                                                <td>
                                                    <span className={`${styles.insStatusPill} ${termGap > 0 ? styles.insStatusPillShort : styles.insStatusPillCovered}`}>
                                                        {termGap > 0 ? 'Shortfall' : 'Covered'}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className={styles.insTypeLabel}>Health Insurance</div>
                                                    <div className={styles.insTypeSub}>2x Annual Income</div>
                                                </td>
                                                <td className={styles.insReqValue}>{formatInsuranceValue(recommendedHealth)}</td>
                                                <td className={styles.insExistValue}>{totalHealthCoverage > 0 ? formatInsuranceValue(totalHealthCoverage) : 'Not added'}</td>
                                                <td className={healthGap > 0 ? styles.insGapShort : styles.insGapCovered}>
                                                    {healthGap > 0 ? formatInsuranceValue(healthGap) : '✓ Covered'}
                                                </td>
                                                <td>
                                                    <span className={`${styles.insStatusPill} ${healthGap > 0 ? styles.insStatusPillShort : styles.insStatusPillCovered}`}>
                                                        {healthGap > 0 ? 'Shortfall' : 'Covered'}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* Policy Detail Table */}
                                    {policies.length > 0 && (
                                        <table className={styles.insPolicyTable}>
                                            <thead>
                                                <tr>
                                                    {['POLICY', 'COVERAGE', 'PREMIUM/YR', 'RENEWAL', 'DEP AGE/LE'].map(h => (
                                                        <th key={h}>{h}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {policies.map((policy, idx) => (
                                                    <tr key={idx}>
                                                        <td>{policy.type}</td>
                                                        <td>{formatInsuranceValue(checkForNullOrNaN(policy.coverage))}</td>
                                                        <td>Rs.{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(policy.premium))}</td>
                                                        <td>{policy.renewalDate || '—'}</td>
                                                        <td>
                                                            {policy.type === 'Term Insurance' && (policy.dependentAge || policy.dependentLifeExpectancy)
                                                                ? `Age ${policy.dependentAge || '—'} LE ${policy.dependentLifeExpectancy || '—'}`
                                                                : '—'
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                                {/* Total Premium Row */}
                                                <tr className={styles.insPolicyTotalRow}>
                                                    <td>Total Premium</td>
                                                    <td></td>
                                                    <td>Rs.{Intl.NumberFormat('en-IN').format(totalPremium)}</td>
                                                    <td colSpan="2"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                {/* Liabilities & Loans */}
                                {loans.length > 0 && (
                                    <div className={styles.insuranceLoansBlock}>
                                        <h3 className={styles.investmentHeading}>Liabilities &amp; Loans</h3>
                                        <table className={styles.loanTable}>
                                            <thead>
                                                <tr>
                                                    {['LOAN TYPE', 'TOTAL LOAN', 'OUTSTANDING LOAN', 'REMAINING', 'MONTHLY EMI'].map(h => (
                                                        <th key={h}>{h}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loans.map((loan, idx) => (
                                                    <tr key={idx}>
                                                        <td>{loan.type}</td>
                                                        <td>{formatInsuranceValue(checkForNullOrNaN(loan.total))}</td>
                                                        <td>{formatInsuranceValue(checkForNullOrNaN(loan.outstanding))}</td>
                                                        <td>{loan.remaining ? `${loan.remaining} yrs` : '—'}</td>
                                                        <td>₹{Intl.NumberFormat('en-IN').format(checkForNullOrNaN(loan.emi))}</td>
                                                    </tr>
                                                ))}
                                                {/* Total Row */}
                                                <tr className={styles.loanTotalRow}>
                                                    <td>Total</td>
                                                    <td>{formatInsuranceValue(totalLoanAmt)}</td>
                                                    <td>{formatInsuranceValue(totalOutstanding)}</td>
                                                    <td></td>
                                                    <td>₹{Intl.NumberFormat('en-IN').format(totalEmi)}/mo</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </div>


                {/* Goal Cashflow Statement */}
                {(userData.investmentDetails.goals?.length > 0 &&
                    <div className={`${styles.cashFlow} ${styles.retirementCashFlowSection} pdf-page-five`} style={{ margin: '32px' }}>
                        <div className={styles.analysisHead}>
                            <div className={styles.redAccent} style={{ backgroundColor: '#2C3327', width: '4px', marginRight: '8px' }}></div>
                            <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#111' }}><b>Goal Cashflow Statement</b></span>
                        </div>
                        <p style={{ fontSize: '0.85rem', color: '#64748b', margin: '0.5rem 0 1rem 0', fontStyle: 'italic' }}>
                            Pre-retirement period — tracks corpus growth, savings, goal withdrawals and capital receipts up to last goal year.
                        </p>
                        <div className={styles.tableWrapper}>
                            <table className={styles.retirementCashFlowTable}>
                                <thead>
                                    <tr>
                                        <th>Age / Year</th>
                                        <th>Opening Balance</th>
                                        <th>Returns</th>
                                        <th>Current Savings</th>
                                        <th className={styles.greenHeader}>Additional Savings</th>
                                        <th>Goal Withdrawal</th>
                                        <th>Net Capital Receipts / Goal Requirement</th>
                                        {/* <th>Net Goal Requirement</th> */}
                                        <th>Year End Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {nonRetirementRows
                                        ?.filter((rown, index, array) => {
                                            const isThirdRow = index % 3 === 0;
                                            const isLastRow = index === array.length - 1;
                                            const withdrawalValue = rown[6];
                                            const hasWithdrawal = withdrawalValue !== null && withdrawalValue !== 0 && withdrawalValue !== '';
                                            return isThirdRow || isLastRow || hasWithdrawal;
                                        })
                                        .map((row, index) => {
                                            const ageVal = row[0];
                                            const yearVal = row[1];
                                            const openingBalance = row[2] ?? 0;
                                            const returns = row[3] ?? 0;
                                            const currentSavings = row[4] ?? 0;
                                            const additionalSavings = row[5] ?? 0;
                                            const goalWithdrawal = row[6] ?? 0;
                                            const netCapitalReceipts = row.length >= 10 ? (row[7] ?? 0) : 0;
                                            const netGoalRequirement = row.length >= 10 ? (row[8] ?? 0) : 0;
                                            const yearEndValue = row.length >= 10 ? (row[9] ?? 0) : (row[7] ?? 0);

                                            const isWithdrawal = goalWithdrawal > 0;
                                            return (
                                                <tr key={index} className={isWithdrawal ? styles.withdrawalRow : ""}>
                                                    <td className={styles.ageYearCell}>
                                                        {ageVal} / {yearVal}
                                                    </td>
                                                    <td>{formatNumberToIndianUnits(openingBalance)}</td>
                                                    <td>{formatNumberToIndianUnits(returns)}</td>
                                                    <td>{formatNumberToIndianUnits(currentSavings)}</td>
                                                    <td className={additionalSavings > 0 ? styles.textGreen : ""}>
                                                        {additionalSavings > 0 ? `+ ${formatNumberToIndianUnits(additionalSavings)}` : formatNumberToIndianUnits(additionalSavings)}
                                                    </td>
                                                    <td className={isWithdrawal ? styles.textRed : ""}>
                                                        {isWithdrawal ? `- ${formatNumberToIndianUnits(goalWithdrawal)}` : formatNumberToIndianUnits(goalWithdrawal)}
                                                    </td>
                                                    <td className={netCapitalReceipts > 0 ? styles.textPurple : ""}>
                                                        {formatNumberToIndianUnits(netCapitalReceipts)}
                                                    </td>
                                                    {/* <td className={netGoalRequirement > 0 ? styles.textRed : ""}>
                                                        {netGoalRequirement > 0 ? `- ${formatNumberToIndianUnits(netGoalRequirement)}` : formatNumberToIndianUnits(netGoalRequirement)}
                                                    </td> */}
                                                    <td className={yearEndValue < 0 ? styles.textRed : styles.textBold}>
                                                        {formatNumberToIndianUnits(yearEndValue)}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        {/* <div style={{ marginTop: '15px', fontSize: '13px', color: '#666', fontStyle: 'italic' }}>
                            <p className='fw-bold'>Your non retirement savings of ₹ {Intl.NumberFormat('en-IN').format(userData.planDetails.NonRetirementContributions * 12)} will be available to meet other goals before retirement or you can adjust your additional savings for retirement by that much amount after meeting the goals</p>
                        </div> */}
                    </div>
                )}

                {/* Retirement Cash Flow Statement */}
                <div className={`${styles.cashFlow} ${styles.retirementCashFlowSection} pdf-page-six ${styles.pdfpagebreakafter}`} style={{ margin: '32px' }}>
                    <div className={styles.analysisHead}>
                        <div className={styles.redAccent} style={{ backgroundColor: '#2C3327', width: '4px', marginRight: '8px' }}></div>
                        <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#111' }}><b>Retirement Cash Flow Statement</b></span>
                    </div>
                    <p style={{ fontSize: '0.85rem', color: '#64748b', margin: '0.5rem 0 1rem 0', fontStyle: 'italic' }}>
                        {userData.planDetails.shortageRYType === 'surplus'
                            ? <>From retirement year onwards — corpus exceeds target with a <span style={{ color: '#16a34a', fontWeight: '700' }}>surplus of ₹{formatNumberToIndianUnits(checkForNullOrNaN(Object.keys(goalsData).length > 0 ? userData?.planDetails?.unallocatedAssetsSurplus : userData.planDetails.shortageRY))}</span>. Tracks comfortable drawdown against inflation-adjusted expenses through life expectancy. ✓</>
                            : 'From retirement year onwards — tracks drawdown of corpus against inflation-adjusted expenses through life expectancy.'
                        }
                    </p>
                    <div className={styles.tableWrapper}>
                        <table className={styles.retirementCashFlowTable}>
                            <thead>
                                <tr>
                                    <th>Age / Year</th>
                                    <th>Begin Assets</th>
                                    <th>Annual Return</th>
                                    <th>Annual Savings</th>
                                    <th className={styles.greenHeader}>Additional Savings</th>
                                    <th>Capital Receipts/Surplus</th>
                                    <th>Expense Withdrawals</th>
                                    <th>Goal Withdrawal</th>
                                    <th>Year End Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(() => {
                                    let lastDisplayedIndex = -1;

                                    return rows?.filter((rown, index, array) => {
                                        const isFirstRow = index === 0;
                                        const isLastRow = index === array.length - 1;

                                        const rowYear = typeof rown[0] === 'string' && rown[0].includes('/')
                                            ? Number(rown[0].split(' / ')[1])
                                            : Number(rown[1]);
                                        const goals = userData?.investmentDetails?.goals || [];

                                        const GRetirmentYear = userData.planDetails.YearsUnitilRetirement + (new Date().getFullYear());
                                        let isGoalWithdrawalYear = false;
                                        goals.forEach((goal) => {
                                            if ((goal.goal_year - 1) === rowYear && goal.goal_year >= GRetirmentYear) {
                                                isGoalWithdrawalYear = true;
                                            }
                                        });

                                        const isGapRow = lastDisplayedIndex === -1 || (index - lastDisplayedIndex >= 5);

                                        if (isFirstRow || isLastRow || isGoalWithdrawalYear || isGapRow) {
                                            lastDisplayedIndex = index;
                                            return true;
                                        }

                                        return false;
                                    }).map((row, index) => {
                                        let ageYear, beginAssets, annualReturn, annualSavings, additionalSavings, capitalReceipts, expenseWithdrawals, goalWithdrawal, yearEndValue;

                                        if (typeof row[0] === 'string' && row[0].includes('/')) {
                                            ageYear = row[0];
                                            beginAssets = row[1];
                                            annualReturn = row[2];
                                            annualSavings = row[3];
                                            additionalSavings = row[4];
                                            capitalReceipts = row[5];
                                            expenseWithdrawals = row[6];
                                            goalWithdrawal = row[7];
                                            yearEndValue = row[8];
                                        } else {
                                            ageYear = `${row[0]} / ${row[1]}`;
                                            beginAssets = row[2];
                                            annualReturn = row[3];
                                            annualSavings = row[4];
                                            additionalSavings = row[5];
                                            capitalReceipts = 0;
                                            expenseWithdrawals = row[6];
                                            goalWithdrawal = 0;
                                            yearEndValue = row[7];
                                        }

                                        const ageVal = parseInt(ageYear.split(' / ')[0]);
                                        const isRetirementYear = ageVal === userData.clientsDetails.year_of_retirement;
                                        const isPostRetirement = ageVal >= userData.clientsDetails.year_of_retirement;

                                        return (
                                            <tr key={index} className={isPostRetirement ? styles.retirementYearRow : ""}>
                                                <td className={styles.ageYearCell}>
                                                    {ageYear} {isRetirementYear && "★"}
                                                </td>
                                                <td>{formatNumberToIndianUnits(beginAssets)}</td>
                                                <td>{formatNumberToIndianUnits(annualReturn)}</td>
                                                <td>{formatNumberToIndianUnits(annualSavings)}</td>
                                                <td className={additionalSavings > 0 ? styles.textGreen : ""}>
                                                    {additionalSavings > 0 ? `+ ${formatNumberToIndianUnits(additionalSavings)}` : formatNumberToIndianUnits(additionalSavings)}
                                                </td>
                                                <td className={capitalReceipts > 0 ? styles.textPurple : ""}>
                                                    {formatNumberToIndianUnits(capitalReceipts)}
                                                </td>
                                                <td>{formatNumberToIndianUnits(expenseWithdrawals)}</td>
                                                <td className={goalWithdrawal > 0 ? styles.textRed : ""}>
                                                    {goalWithdrawal > 0 ? `- ${formatNumberToIndianUnits(goalWithdrawal)}` : formatNumberToIndianUnits(goalWithdrawal)}
                                                </td>
                                                <td className={yearEndValue < 0 ? styles.textRed : styles.textBold}>
                                                    {formatNumberToIndianUnits(yearEndValue)}
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </table>
                    </div>
                    {/* Table Legend */}
                    <div className={styles.tableLegend}>
                        ★ = Retirement year | Yellow rows = post-retirement | Purple = capital receipt inflows | Red = withdrawals | Green = Additional Savings (new SIP for goals + retirement)
                    </div>
                </div>

                {/* Disclaimer */}
                <div className={styles.disclaimer + " pdf-page-last"}>
                    < div className={styles.discHead}><span>Disclaimer</span></div>
                    <p>
                        In the preparation of this Retirement Plan (&quot;Plan&quot;) and its content including images, text, files, etc., Bajaj Capital Private Limited (BCIAPL) has used information available in public domain including inputs submitted by the client. This plan is client-specific in nature and is subject to customization doing risk profiling of each client.
                    </p>
                    <p>

                        This plan is developed in-house by BCIAPL in the capacity of a SEBI registered Investment Advisor [SEBI Reg. No. INA100001398]. Information and content related to Insurance product (s) are provided by M/s Bajaj Capital Insurance Broking Limited(&quot;BICIBL&quot;) a Group Company within the Bajaj Capital Group. BCIBL is an IRDA licensed Composite Broker bearing License No. 241, Broker Code CB 042/02.</p>
                    <p>

                        The information provided hereinabove is generic in nature, for knowledge and information purposes only. Before taking decision to take out any investment product(s) and/ or insurance policy(ies), you are requested to take appropriate guidance from an investment Advisor/ lnsurance Expert and for tax related matters from a Tax Consultant.</p>
                    <p>

                        No fees is being charged for preparation of the Plan and the user of the is under no obligation to avail implementation of the Plan from BCIAPL.
                    </p>
                    <p>
                        Mutual Funds Investments are to market risk and read the offer document before investing.
                    </p>
                    <p>
                        Retirement plan is prepared basis assumptions of inflation, expected returns from various investment options for a long term horizon and actual performance may vary from the indicated figures used in plan for illustration purposes.
                    </p>
                </div>
            </div > : <div><h1>LOADING...</h1></div>
            }
        </>
    )
}

export default ClientPdf